﻿/*
Copyright MITSUBISHI Elec.
*/

/**
 * BlenderGrid
 *
 * @module BlenderGrid
 * @main BlenderGrid
 */

/**
 * 行ステータス: 新規行
 *
 * @static
 * @final
 * @property {string} ROW_STATUS_NEW 新規行
 */
BlenderGrid.ROW_STATUS_NEW = "newRow";
/**
 * 行ステータス: 削除行
 *
 * @static
 * @final
 * @property {string} ROW_STATUS_DELETE 削除行
 */
BlenderGrid.ROW_STATUS_DELETE = "deleteRow";

/**
 * CSSクラス: 削除行
 *
 * @static
 * @final
 * @property {string} CSS_CLASS_ROW_DELETED CSS削除行
 */
BlenderGrid.CSS_CLASS_ROW_DELETED = "rowdeleted";
/**
 * CSSクラス: エラーセル
 *
 * @static
 * @final
 * @property {string} CSS_CLASS_ERROR_CELL CSSエラー行
 */
BlenderGrid.CSS_CLASS_ERROR_CELL = "errorcell";
/**
 * CSSクラス: ダーティセル
 *
 * @static
 * @final
 * @property {string} CSS_CLASS_DIRTY_CELL ダーティセル
 */
BlenderGrid.CSS_CLASS_DIRTY_CELL = "dirtycell";

/**
 * ReadOnly種別: 列
 *
 * @static
 * @final
 * @property {string} READONLY_TYPE_COLUMN ReadOnly種別: 列
 */
BlenderGrid.READONLY_TYPE_COLUMN = "column";
/**
 * ReadOnly種別: セル
 *
 * @static
 * @final
 * @property {string} READONLY_TYPE_CELL ReadOnly種別: セル
 */
BlenderGrid.READONLY_TYPE_CELL = "cell";

/** 削除操作要否のデフォルト値 */
BlenderGrid.ENABLE_DELETE_ACTION_DEFAULT = true;

/**
 * ## BlenderGrid
 * Gridコンポーネント(行ベース)。  
 *  
 * セル種別:'bl_btn'を使用かつ文字コードにUTF-8以外を使用している場合、釦名が文字化けするので、下記のようにcharsetに'UTF-8'を明示的に指定する。  
 * &lt;script src="../codebase/blender/grid/excells/blendergrid_excell_bl_btn.js" charset="UTF-8"&gt;&lt;/script&gt;  
 *  
 * 又は、セルの属性値の設定で、釦名を設定する。  
 * putAttribute("clearBtnLabel[row_行数-列数]","クリア");  
 * putAttribute("selectBtnLabel[row_行数-列数]","選択");  
 *  
 * @class BlenderGrid
 * @extends [dhtmlXGridObject]
 * @module BlenderGrid
 * @constructor
 * @param id {string} div要素のid
 */
function BlenderGrid(id){
	this.tagId = id;
	this.targetObj = $("#"+id);
	this.dirtyFlg = false;
	this.standardColor = "#000000";
	this.dirtyColor = "#0000ff";
	this.colNames = [];
	this.minCellWidth = [];
	this._userAttr = {};
	this._enableCopyPasteFlg = false;
	this._validRule = {}; // 精査ルール
	this._validLogic = {}; // 精査ロジック
	this._validRemarks = {}; // 備考精査条件表示用
	this._readOnlyEXcellMap = {};
	this._deleteEXcellMap = {};
	this.defaultReadonlyType = BlenderGrid.READONLY_TYPE_COLUMN; // デフォルトのReadOnly種別
	this.readonlyMode = 0; // 0:編集可, 1:列モードReadOnly, 2:セルモードReadOnly
	this.quickDeleteFlg = false; // deleteRowで削除マークするか、削除するか
	this.newEntryDeleteFlg = false; // 新規行を削除するか
	this.delRowCellTypeChange = [1];
	this.defaultValueSupport = false; // デフォルト値処理の対応有無

	// 削除操作の要否。削除操作を必要としない画面の場合は本パラメータを
	// false にすることで表示性能が改善される場合がある。
	this.enableDeleteActionFlag = BlenderGrid.ENABLE_DELETE_ACTION_DEFAULT;

	this.startColIdx = null; // 有効カラム開始index
	this.endColIdx = null; // 有効カラム終了index
	this.topLinkGrid; // grid link
	this.bottomLinkGrid; // grid link
	this.leftLinkGrid; // grid link
	this.rightLinkGrid; // grid link

	this.stg1_textColor = null; // undo/redo用
	this.stg1_className = null; // undo/redo用
	this.stg1_change_flag = false; // undo/redo用
	this.stg1_dirty_flag = false; // undo/redo用

	this._is_mouseup = false;
	this._isCustomScroll = false;
	var self = this;

	// グリッド用のdivのheight指定が省略の場合、dhtmlXGridObject側で0pxと扱われないよう、autoを設定する
	var entBox = document.getElementById(id);
	if (!entBox.style.height) {
		entBox.style.height = "auto";
	}

	// オブジェクトマネージャに登録
	BlenderObjectManager.putObject(id, this, "grid");

	dhtmlXGridObject.call(this, id);

	//
	if(this.skin==null) this.skin = "blender";
	this.calendarSkin = (this.skin == "blender_rb" || this.skin == "blender_cb") ? "blender" : this.skin;

	//if(_isIE>=7) _isIE=true;

	this._srdh = 20; // スマートレンダリング用１行当たりの高さ修正

	// updateValidColumnRangeの呼び出しを追加するため、init関数の差し替えを実施。
	this._dhtmlXGridInit = this.init;
	this.init = function() {
		this.i18n = BlenderDhtmlxCustomSettings.gridLangData;
		if (this.lang == null) {
			for(var key in this.i18n) {
				if (this.i18n[key] && this.i18n[key]["selectBtnLabel"]) {
					this.lang = key;
					break;
				}
			}
		}
		this.setSkin(this.skin);
		this._dhtmlXGridInit();
		this.updateValidColumnRange();
	}

	// 表示エリア幅を固定し、不要なスクロールバーの表示を抑えるコードに差し替える。
	this._reset_view = function(skip){
		if (!this.obj.rows[0])return;
		var tb = this.obj.rows[0].parentNode;

		var tr = tb.removeChild(tb.childNodes[0], true)
		if (_isKHTML)
			for (var i = tb.parentNode.childNodes.length-1; i>= 0; i--){
				if (tb.parentNode.childNodes[i].tagName=="TR")
					tb.parentNode.removeChild(tb.parentNode.childNodes[i],true)
			}
		else if (_isIE)
			for (var i = tb.childNodes.length-1; i>=0; i--)
				tb.childNodes[i].removeNode(true);
		else
			tb.innerHTML="";

		var w = $(tb).width();

		tb.appendChild(tr)
		this.rowsCol=dhtmlxArray();
		if (this._sst)
			this.enableStableSorting(true);

		this._fillers=this.undefined;
		if (!skip){
			if (_isIE && this._srnd){
				this.render_dataset()
			}else
				this.render_dataset()
		}

		$(tb).width(w);
	};

	// スマートレンダリング対応に処理を差し替える。
	this.cells = function(row_id, col) {
		if (arguments.length == 0)
			return this.cells4(this.cell);

		var row_index = this.getRowIndex(row_id);
		if( row_index>=0 ) {
			return this.cells2(row_index, col);
		}else {
			var row = this.getRowById(row_id);
			if( !row ) return null;

			var cell = (row._childIndexes ?
				row.childNodes[row._childIndexes[col]] : row.childNodes[col]);
			return this.cells4(cell);
		}
	};

	// スマートレンダリング対応に処理を差し替える。
	this.setCellExcellType = function(rowId, cellIndex, type){
		var rowIdx = this.getRowIndex(rowId);
		var row = this.render_row(rowIdx);
		this.changeCellType(row, cellIndex, type)
	};

	// dma時有効時のセル処理(通常:cells4)
	this.cells5 = function(cell, type){
		var type = type||(cell._cellType||this.cellType[cell._cellIndex]);

		if (!this._ecache[type]){
			if (!window["eXcell_"+type])
				var tex = eXcell_ro;
			else
				var tex = window["eXcell_"+type];

			this._ecache[type]=new tex(cell);
		}
		this._ecache[type].cell=cell;
		// キャッシュされているコンボはクリアしておく。
		this._ecache[type].combo = null;
		return this._ecache[type];
	};
	//
	this._filterA = function(column,value){
		if (value=="") return;
		var d=true;
		if (typeof(value)=="function") d=false;
		else value=(value||"").toString().toLowerCase();
		if (!this.rowsBuffer.length) return;

		for (var i=this.rowsBuffer.length-1; i>=0; i--) {
			var tmpVal = this._get_cell_value(this.rowsBuffer[i],column);
			if(tmpVal == null) tmpVal = "";
//			if (d?(this._get_cell_value(this.rowsBuffer[i],column).toString().toLowerCase().indexOf(value)==-1):(!value.call(this, this._get_cell_value(this.rowsBuffer[i],column),this.rowsBuffer[i].idd)))
			if (d?(tmpVal.toLowerCase().indexOf(value)==-1):(!value.call(this, this._get_cell_value(this.rowsBuffer[i],column),this.rowsBuffer[i].idd))) {
				this.rowsBuffer.splice(i,1);//filter row
			}
		}
	};

	// ReadOnly時のセル種別変更に対応した処理に差し替える。
	this.changeCellType = function(row, cellIndex, type){
		type = type||this.cellType[cellIndex];

		if( this.readonlyMode != 0 ) {
			type = this._getReadOnlyCellType(type);
		}

		var c = this.cells3(row, cellIndex);
		var val = c.getValue();
		c.cell._cellType=type;

		c = this.cells3(row, cellIndex);
		c.setValue(val)
	};

	// 下端行選択時のスクロール処理をDHTMLX v.2.5相当の仕様に戻す。
	// DHTMLX v.2.5（旧版）：下端選択時、下端行を1行スクロールアップ。
	// DHTMLX v.3.6（現版）：下端選択時、下端行がグリッドのトップになるようページ単位でスクロールアップ。
	// DHTMLX v.4.1.2/v.5（参考）：下端クリック時、何も起きない（moveToVisibleが呼ばれない）。[↓]キー操作ではv.3.6と同じ動作。
	this.moveToVisible=function(cell_obj, onlyVScroll){
		if (this.pagingOn){
			var newPage=Math.floor(this.getRowIndex(cell_obj.parentNode.idd) / this.rowsBufferOutSize)+1;
			if (newPage!=this.currentPage)this.changePage(newPage)
		};
		if (!cell_obj.offsetHeight){
			var mask=this._realfake?this._fake.rowsAr[cell_obj.parentNode.idd]:cell_obj.parentNode;
			var h=this.rowsBuffer._dhx_find(mask)*this._srdh;
			return this.objBox.scrollTop=h
		};
		try{
			var distance = cell_obj.offsetLeft+cell_obj.offsetWidth+20;
			var scrollLeft = 0;
			if (distance > (this.objBox.offsetWidth+this.objBox.scrollLeft)){
				if (cell_obj.offsetLeft > this.objBox.scrollLeft)
					scrollLeft=cell_obj.offsetLeft-5
			}else if (cell_obj.offsetLeft < this.objBox.scrollLeft){
				distance-=cell_obj.offsetWidth*2/3;
				if (distance < this.objBox.scrollLeft)
					scrollLeft=cell_obj.offsetLeft-5
			};
			if ((scrollLeft)&&(!onlyVScroll))
				this.objBox.scrollLeft=scrollLeft;
			var distance = cell_obj.offsetTop+cell_obj.offsetHeight+20;
			if (distance > (this.objBox.offsetHeight+this.objBox.scrollTop)){
				var scrollTop = distance-this.objBox.offsetHeight
			}
			else if (cell_obj.offsetTop < this.objBox.scrollTop){
				var scrollTop = cell_obj.offsetTop-5
			};
			if (scrollTop)
				this.objBox.scrollTop=scrollTop
		}catch (er){
		}
	};
	/**
	 * 指定した行を削除する。
	 * ※スマートレンダリング有効時に、行を削除し 1行->0行になると
	 * エラーが発生するため処理を差し替える。
	 *
	 * Also see {{#crossLink "BlenderGrid/deleteRow:method"}}{{/crossLink}}
	 *
	 * @method _deleteRow
	 * @private
	 * @param rowId {string} 行ID
	 * @param node {object} ノード
	 */
	this._deleteRow = function(row_id, node){
		if (!node) node=this.getRowById(row_id);
		if (!node) return;
		this.editStop();

		if (this.callEvent("onBeforeRowDeleted", [row_id])== false) {
			return false;
		}

		var pid=0;
		if (this.cellType._dhx_find("tree")!= -1 && !this._realfake){
			pid=this._h2.get[row_id].parent.id;
			this._removeTrGrRow(node)
		}else {
			if (node.parentNode) {
				node.parentNode.removeChild(node);
			}
			var ind = this.rowsCol._dhx_find(node);
			if (ind != -1) {
				this.rowsCol._dhx_removeAt(ind);
			}
			for (var i = 0;i < this.rowsBuffer.length;i++) {
				if (this.rowsBuffer[i]&&this.rowsBuffer[i].idd == row_id){
					this.rowsBuffer._dhx_removeAt(i);
					ind=i;
					break;
				}
			}
		};

		this.rowsAr[row_id]=null;
		for (var i = 0;i < this.selectedRows.length;i++) {
			if (this.selectedRows[i].idd == row_id) {
				this.selectedRows._dhx_removeAt(i);
			}
		}

		if (this._srnd){
			if( null!=this._fillers ) {
				for (var i = 0;i < this._fillers.length;i++){
					var f = this._fillers[i]
					if (!f) continue;
					if (f[0] >= ind) f[0]=f[0]-1;
					else if (f[1] >= ind) f[1]=f[1]-1
				};
			}
			this._update_srnd_view()
		};
		if (this.pagingOn)
			this.changePage();
		if (!this._realfake)
			this.callEvent("onAfterRowDeleted", [row_id,pid]);
		this.callEvent("onGridReconstructed", []);
		if (this._ahgr)
			this.setSizes();return true
	}

	/**
	 * 指定した行に削除マークを付与する。
	 *
	 * @method deleteRow
	 * @param rowId {string} 行ID
	 * @see setDelRowCellTypeChange
	 * @see undeleteRow
	 */
	this.deleteRow = function(rowId) {
		if(!rowId) return;

		if( this.quickDeleteFlg ) {
			this._deleteRow(rowId);
		}else {
			var rowIdx = this.getRowIndex(rowId);

			var row = this.render_row(rowIdx);
			if( this.newEntryDeleteFlg && this.hasRowStatus(row,BlenderGrid.ROW_STATUS_NEW) ) {
				this._deleteRow(rowId);

				if( this.getRowsNum() > 0 && rowIdx == this.getRowsNum() ) {
					this.selectRow(this.getRowsNum()-1);
				}
			}else if( this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
				// NOP
			}else {
				this.addRowStatus(row,BlenderGrid.ROW_STATUS_DELETE);
				$(row).addClass(BlenderGrid.CSS_CLASS_ROW_DELETED);

				for (var i=0; i<this.getColumnsNum(); i++){
					if( this.isDelRowCellTypeChange(i) ) {
						var c = this.cells3(row, i);

						var cell = c.cell;
						var cellType = (cell._cellType || this.cellType[cell._cellIndex]);
						cellType = this._getDeleteCellType(cellType);
						this.changeCellType(row, i, cellType)
					}
				}

				//if( rowIdx > 0 ) {
				//	this.selectRow(rowIdx-1);
				//}

				this.callEvent("onDeleteMark", [row.idd, 1]);
			}
		}
	}

	/**
	 * 指定した行の削除マークを復元する。
	 *
	 * @method updeleteRow
	 * @param rowId {string} 行ID
	 */
	this.undeleteRow = function(rowId) {
		if(!rowId) return;

		if( !this.quickDeleteFlg ) {
			var rowIdx = this.getRowIndex(rowId);

			var row = this.render_row(rowIdx);
			if( this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
				this.removeRowStatus(row,BlenderGrid.ROW_STATUS_DELETE);
				$(row).removeClass(BlenderGrid.CSS_CLASS_ROW_DELETED);

				for (var i=0; i<this.getColumnsNum(); i++){
					if( this.isDelRowCellTypeChange(i) ) {
						var c = this.cells3(row, i);

						var cell = c.cell;
						var cellType = (cell._cellType || this.cellType[cell._cellIndex]);
						cellType = this._getEditableCellType(cellType);
						this.changeCellType(row, i, cellType)

						//this._validate(c,rowId,i,c.getValue());
					}
				}

				this.callEvent("onDeleteMark", [row.idd, 0]);
			}else {
				// NOP
			}
		}
	}

	/**
	 * 指定したグリッドの幅に応じて、列幅を最適なサイズに設定する。
	 *
	 * @method setColumnSizes
	 * @param gridWidth {number} グリッドの幅
	 */
	this.setColumnSizes=function(gridWidth){
		var summ = 0;
		var fcols = [];

		for (var i = 0;i < this._cCount;i++){
			if ((this.initCellWidth[i] == "*") && !this._hrrar[i]){
				this._awdth=false;
				fcols.push(i);
				continue;
			};
			if (this.cellWidthType == '%'){
				if (typeof this.cellWidthPC[i]=="undefined")
					this.cellWidthPC[i]=this.initCellWidth[i];
				this.cellWidthPX[i]=Math.floor(gridWidth*this.cellWidthPC[i]/100)||0;
			}else{
				if (typeof this.cellWidthPX[i]=="undefined")
					this.cellWidthPX[i]=this.initCellWidth[i]
			};
			if( this.minCellWidth[i] && !this.isColumnHidden(i) ) {
				var minWidth = parseInt(this.minCellWidth[i]);
				if( this.cellWidthPX[i] < minWidth ) this.cellWidthPX[i] = minWidth;
			}
			if (!this._hrrar[i]) {
				summ+=this.cellWidthPX[i]*1;
			}
		};

		if (fcols.length){
			var ms = Math.floor((gridWidth-summ)/fcols.length);
			if (ms < 0)
				ms=1;
			for (var i = 0;i < fcols.length;i++){
				var next=Math.max((this._drsclmW ? this._drsclmW[fcols[i]] : 0),ms);
				if( this.minCellWidth[fcols[i]] ) {
					var minWidth = parseInt(this.minCellWidth[fcols[i]]);
					if( next < minWidth ) next = minWidth;
				}
				this.cellWidthPX[fcols[i]]=next;
				summ+=next;
			};
			this._setAutoResize();
		};

		this.obj.style.width=summ+"px";
		this.hdr.style.width=summ+"px";
		if (this.ftr)
			this.ftr.style.width=summ+"px";
		this.chngCellWidth();
		return summ
	};

	/**
	 * 編集中止
	 * @method editStop
	 */
	this.editStop=function(mode){
		if (_isOpera)
			if (this._Opera_stop){
				if ((this._Opera_stop*1+50)> (new Date).valueOf())
					return;
				this._Opera_stop=null
			};

		if (this.editor&&this.editor != null){
			this.editor.cell.className=this.editor.cell.className.replace("editable", "");

			if (mode){
				var t = this.editor.val;

				this.editor.detach(true); // 修正
				this.editor.setValue(t);
				this.editor=null;
				return
			};

			if (this.editor.detach())
				this.cell.wasChanged=true;
			var g = this.editor;
			this.editor=null;
			var z = this.callEvent("onEditCell", [ 2, this.row.idd, this.cell._cellIndex, g.getValue(), g.val ]);

			if (( typeof (z)== "string")||( typeof (z) == "number"))
				g[g.setImage ? "setLabel" : "setValue"](z);
			else if (!z)
				g[g.setImage ? "setLabel" : "setValue"](g.val)
		}
	};

	this.startColResize=function(ev){
		self._is_mouseup = false;
		if (this.resized) this.stopColResize();
		this.resized=null;
		var el = ev.target||ev.srcElement;
		if (el.tagName != "TD")
			el=this.getFirstParentOfType(el, "TD")
		var x = ev.clientX;
		var tabW = this.hdr.offsetWidth;
		var startW = parseInt(el.offsetWidth)

		self.setActive(true);
		if (el.tagName == "TD"&&el.style.cursor != "default"){
			if ((this._drsclmn)&&(!this._drsclmn[el._cellIndex]))
				return;

			this._old_d_mm=document.body.onmousemove;
			this._old_d_mu=document.body.onmouseup;
			this._old_d_b=document.body.onblur;

			var dWins = $((document.defaultView?document.defaultView:document.parentWindow).parent.document.documentElement).find(".dhxwin_active");
			var dWinsEv = [];
			if(dWins&&dWins.length>0) {
				for(var i=0;i<dWins.size();i++) {
					dWinsEv[i] = $(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.body.onmouseup;
				}
			}

			this._old_r_mo=function(){
				if(dWins&&dWins._isWindow) {
					if(dWins&&dWins.length>0) {
						for(var i=0;i<dWins.size();i++) {
							if (dWins[i]&&$(dWins[i]).find(".dhx_cell_cont_wins").length>0) {
								if ($(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.addEventListener) {
									$(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.addEventListener('mouseup', self._old_r_mu, false);
								} else {
									if ($(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.attachEvent) {
										$(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.attachEvent('onmouseup', self._old_r_mu);
									}
								}
							}
						}
					}
				} else {
					if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.removeEventListener) {
						(document.defaultView?document.defaultView:document.parentWindow).parent.document.removeEventListener('mouseout', self._old_r_mo, false);
					} else {
						if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.detachEvent) {
							(document.defaultView?document.defaultView:document.parentWindow).parent.document.detachEvent('onmouseout', self._old_r_mo);
						}
					}
				}
			};
			if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.addEventListener) {
				(document.defaultView?document.defaultView:document.parentWindow).parent.document.addEventListener('mouseout', this._old_r_mo, false);
			} else {
				if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.attachEvent) {
					(document.defaultView?document.defaultView:document.parentWindow).parent.document.attachEvent('onmouseout', this._old_r_mo);
				}
			}

			this._old_r_mu=function(){
				self._is_mouseup=true;
			};
			if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.addEventListener) {
				(document.defaultView?document.defaultView:document.parentWindow).parent.document.addEventListener('mouseup', this._old_r_mu, false);
			} else {
				if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.attachEvent) {
					(document.defaultView?document.defaultView:document.parentWindow).parent.document.attachEvent('onmouseup', this._old_r_mu);
				}
			}

			document.body.onblur=function(){
				self._is_mouseup=true;
			}
			document.body.onmousemove=function(e){
				if (self._is_mouseup) {
					document.body.onmousemove=self._old_d_mm||"";
					document.body.onmouseup=self._old_d_mu||"";
					document.body.onblur=self._old_d_b||"";
					if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.removeEventListener) {
						(document.defaultView?document.defaultView:document.parentWindow).parent.document.removeEventListener('mouseout', self._old_r_mo, false);
					} else {
						(document.defaultView?document.defaultView:document.parentWindow).parent.document.detachEvent('onmouseout', self._old_r_mo);
					}
					if ((document.defaultView?document.defaultView:document.parentWindow).parent.document.removeEventListener) {
						(document.defaultView?document.defaultView:document.parentWindow).parent.document.removeEventListener('mouseup', self._old_r_mu, false);
					} else {
						(document.defaultView?document.defaultView:document.parentWindow).parent.document.detachEvent('onmouseup', self._old_r_mu);
					}
					for(var i=0;i<dWins.size();i++) {
						if (dWins[i]&&$(dWins[i]).find(".dhx_cell_cont_wins").length>0) {
							if ($(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.removeEventListener) {
								$(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.removeEventListener('mouseup', self._old_r_mu, false);
							} else {
								if ($(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.detachEvent) {
									$(dWins[i]).find(".dhx_cell_cont_wins").find("iframe")[0].contentWindow.document.detachEvent('onmouseup', self._old_r_mu);
								}
							}
						}
					}
					dWinsEv = null;
				} else {
					if (self && self.isActive) {
						self.doColResize(e||window.event, el, startW, x, tabW);
					} else {
						self._is_mouseup=true;
					}
				}
			}
			document.body.onmouseup=function(){
				self._is_mouseup=true;
				if (self)
					self.stopColResize();
			}
		}
	};

	this._createHRow=function(data, parent){
		if (!parent){
			if (this.entBox.style.position!="absolute")
				this.entBox.style.position="relative";
			var z = document.createElement("DIV");
			z.className="c_ftr".substr(2);
			this.entBox.appendChild(z);
			var t = document.createElement("TABLE");
			t.cellPadding=t.cellSpacing=0;

			if (!_isIE || _isIE == 8){
				t.width="100%";
				t.style.paddingRight="20px";
			}
			t.style.marginRight="20px";
			t.style.tableLayout="fixed";

			z.appendChild(t);
			t.appendChild(document.createElement("TBODY"));
			this.ftr=parent=t;

			var hdrRow = t.insertRow(0);
			var thl = ((this.hdrLabels.length <= 1) ? data[0].length : this.hdrLabels.length);

			for (var i = 0; i < thl; i++){
				hdrRow.appendChild(document.createElement("TH"));
				hdrRow.childNodes[i]._cellIndex=i;
			}

			if (_isIE && _isIE<8)
				hdrRow.style.position="absolute";
			else
				hdrRow.style.height='auto';
		}
		var st1 = data[1];
		var z = document.createElement("TR");
		parent.rows[0].parentNode.appendChild(z);

		for (var i = 0; i < data[0].length; i++){
			if (data[0][i] == "#cspan"){
				var pz = z.cells[z.cells.length-1];
				pz.colSpan=(pz.colSpan||1)+1;
				continue;
			}

			if ((data[0][i] == "#rspan")&&(parent.rows.length > 1)){
				var pind = parent.rows.length-2;
				var found = false;
				var pz = null;

				while (!found){
					var pz = parent.rows[pind];

					for (var j = 0; j < pz.cells.length; j++)
					if (pz.cells[j]._cellIndex == i){
						found=j+1;
						break;
					}
					pind--;
				}

				if( pind>=0 ) {
					pz=pz.cells[found-1];
					pz.rowSpan=(pz.rowSpan||1)+1;
				}
				continue;
				//            data[0][i]="";
			}

			var w = document.createElement("TD");
			w._cellIndex=w._cellIndexS=i;
			if (this._hrrar && this._hrrar[i] && !_isIE)
				w.style.display='none';

			if (typeof data[0][i] == "object")
				w.appendChild(data[0][i]);
			else {
				if (this.forceDivInHeader)
					w.innerHTML="<div class='hdrcell'>"+(data[0][i]||"&nbsp;")+"</div>";
				else
					w.innerHTML=(data[0][i]||"&nbsp;");

				if ((data[0][i]||"").indexOf("#") != -1){
					var t = data[0][i].match(/(^|{)#([^}]+)(}|$)/);

					if (t){
						var tn = "_in_header_"+t[2];

						if (this[tn])
							this[tn]((this.forceDivInHeader ? w.firstChild : w), i, data[0][i].split(t[0]));
					}
				}
			}
			if (st1)
				w.style.cssText=st1[i];

			z.appendChild(w);
		}
		var self = parent;

		if (_isKHTML){
			if (parent._kTimer)
				window.clearTimeout(parent._kTimer);
			parent._kTimer=window.setTimeout(function(){
					parent.rows[1].style.display='none';
					window.setTimeout(function(){
							parent.rows[1].style.display='';
					}, 1);
			}, 500);
		}
	};

	this._init_validate();
	this._init_readOnlyEXcellMap();
	this._init_deleteEXcellMap();
	this._init_context_menu();

	this.assignTblCtrlKey();

	this.attachEvent("onBlockLeftClick", function(){
		this._HideSelection();
	});
	this.attachEvent("onHeaderClick", function(colIdx,e){
		this.editStop();
		return true;
	});
	this.attachEvent("onEditCell", function(stage,rId,cInd,nValue,oValue){
		if( stage==2 && nValue!==oValue ) {
			//alert("moddify!!  nValue: "+nValue+", oValue: "+oValue);
			var c = this.cells(rId, cInd);
			this.setDirtyFlg(true);
			this._setDirtyMark(c);
			this._validate(c,rId,cInd,nValue);
		}
		return true;
	});
	this.attachEvent("onRowPaste", function(rId,pasteColIdxes){
		var rowIdx = this.getRowIndex(rId);
		var row = this.render_row(rowIdx);
		for( var i=0; i<this.getColumnsNum(); i++ ) {
			var c = this.cells3(row, i);
			var nValue = c.getValue();
			if( c.wasChanged() ) {
				this.setDirtyFlg(true);
				this._setDirtyMark(c);
				this._validate(c,rId,i,nValue);
			}
		}
		return true;
	});
	this.attachEvent("onRowAdded", function(newRowId){
		var rowIdx = this.getRowIndex(newRowId);
		var row = this.render_row(rowIdx);
		this.addRowStatus(row,BlenderGrid.ROW_STATUS_NEW);

		this.selectRowById(newRowId);

		var rowDatas = [];
		for( var i=0; i<this.getColumnsNum(); i++ ) {
			var c = this.cells3(row, i);
			rowDatas[i] = c.getValue();
		}

		if( typeof BlenderGridRowCtrlCommand == "function" ) {
			var cmd = new BlenderGridRowCtrlCommand(this,newRowId,rowIdx);
			cmd.type = BlenderGridRowCtrlCommand.TYPE_ADD;
			cmd.rowData = rowDatas;
			cmd.old_dirty_flag = this.isDirty();
			cmd.new_dirty_flag = true;

			if (this._IsUndoRedoEnabled) {
				this._pushUndoBuffer(cmd);
			}
		}

		this.setDirtyFlg(true);
	});
	this.attachEvent("onBeforeRowDeleted", function(rId){
		this.setDirtyFlg(true);
	});
	this.attachEvent("onDeleteMark", function(rowId,status){
		this.setDirtyFlg(true);
	});
	this.attachEvent("onRowSelect", function(id,ind){
		var g;
		g = this.leftLinkGrid;
		while( g && g!=this ) {
			g._HideSelection();
			g.clearSelection();
			g = g.leftLinkGrid;
		}
		g = this.rightLinkGrid;
		while( g && g!=this ) {
			g._HideSelection();
			g.clearSelection();
			g = g.rightLinkGrid;
		}
	});
	this.attachEvent("onColumnHidden", function(index,state){
		this._HideSelection();
		this.updateValidColumnRange();
	});
	this.attachEvent("onXLE", function(){
		//alert("load!");
		this.setDirtyFlg(false);
		this._HideSelection();

		this.updateValidColumnRange();

		this.sortImg.style.display="none";
		this.fldSorted=null;
		this.r_fldSorted=null;
	});
	this.attachEvent("onClearAll", function(){
		this._HideSelection();
		this.setSizes();
	});
	this._setSkin = this.setSkin;
	this.setSkin = function(name) {
		this._setSkin(name);
		this.attachEvent("onGridReconstructed",function(){
			//alert("onGridReconstructed");
			for (var i=0;i<this.getRowsNum();i++){
				var row = this.render_row(i);
				//alert(">> "+row.idd+" - "+this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE));
				if( this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
					$(row).addClass(BlenderGrid.CSS_CLASS_ROW_DELETED);
				}else {
					$(row).removeClass(BlenderGrid.CSS_CLASS_ROW_DELETED);
				}
			}
		});
	}
	this.setCalendarSkin = function(name) {
		this.calendarSkin = name;
	}
	this._custom_attachEvent();
	this._setSizes = this.setSizes;
	this.setSizes = function(){
		if (dhtmlx.CustomScroll){
			if (this._isCustomScroll && !dhtmlx.$customScroll){
				dhtmlx.$customScroll = true;
				this._setSizes();
				dhtmlx.$customScroll = false;
			}else{
				this._setSizes();
			}
		}else{
			this._setSizes();
		}
	}
	this._doKey = this.doKey;
	this.doKey=function(ev){
		if (!ev)
			return true;

		if ((ev.target||ev.srcElement).value !== window.undefined){
			var zx = (ev.target||ev.srcElement);

			if (zx.className!="dhxcombo_input"&&((!zx.parentNode)||(zx.parentNode.className.indexOf("editable") == -1)))
				return true;
		}

		if ((globalActiveDHTMLGridObject)&&(this != globalActiveDHTMLGridObject))
			return globalActiveDHTMLGridObject.doKey(ev);

		if (this.isActive == false){
			if (!this.callEvent("onKeyPress", [
					ev.keyCode,
				ev.ctrlKey,
				ev.shiftKey,
				ev
			]))
			return true;
		}

		if (this._htkebl)
			return true;

		if (!this.callEvent("onKeyPress", [
				ev.keyCode,
			ev.ctrlKey,
			ev.shiftKey,
			ev
		]))
		{
			if (ev.preventDefault)
				ev.preventDefault();
			ev.cancelBubble=true;
			return false;
		}

		var code = "k"+ev.keyCode+"_"+(ev.ctrlKey ? 1 : 0)+"_"+(ev.shiftKey ? 1 : 0);

		if (this.cell){ //if selection exists in grid only
			if (this._key_events[code]){
				if (false === this._key_events[code].call(this))
					return true;

				if (ev.preventDefault)
					ev.preventDefault();
				ev.cancelBubble=true;
				return false;
			}

			if (this._key_events["k_other"])
				this._key_events.k_other.call(this, ev);
		}

		return true;
	}
	dhtmlxEvent(document, "mouseup", function(){
		if(!self._is_mouseup) self._is_mouseup = true;
	});
	dhtmlxEvent(document, "click", function(){
		if(self&&self.entBox!=null) {
			if (self.editStop) self.editStop();
			if (self.isActive) self.setActive(false);
		}
	});
};

// Extends
BlenderGrid.inherit(dhtmlXGridObject);

/**
 * グリッドの制御キーの割り当てを行う。
 *
 * @method assignTblCtrlKey
 */
BlenderGrid.prototype.assignTblCtrlKey = function(){
	this.attachEvent("onKeyPress", function(code,ctrl,shift) {

		var ret = true;
		if( ctrl ) {
			if(code==65&&this._enableCopyPasteFlg) {
				// CTRL+A: Select All
				//this._update_srnd_view_pos(0,this.getRowsNum());
				//this.selectCopyBlock(0,0,this.getRowsNum()-1,this.getColumnsNum()-1);
				this.selectedAll();
				ret = false;
			}else if(code==67&&this._enableCopyPasteFlg) {
				// CTRL+C: Copy
				this.copyBlockToClipboard();
			}else if(code==86&&this._enableCopyPasteFlg){
				// CTRL+V: Paste
				this.pasteBlockFromClipboard();
			}else if(code==89) {
				// CTRL+Y: Redo
				this.doRedo();
			}else if(code==90) {
				// CTRL+Z: Undo
				this.doUndo();
			}else if(code==32) {
				// CTRL+Space: Select line
				this.selectCopyLine(this.getSelectedRowId());
				ret = false;
			}
		}else if (shift && !this.editor) {
			if (code==37 || code==38 || code==39 || code==40) {
				ret = this.processMoveKey(code);
				// 選択中のセルから rowIdx. colIdx を取得。
				var rowId = this.getSelectedRowId();
				if( !rowId ) return false;
				var rowIdx = this.getRowIndex(rowId);
				var colIdx = this.getSelectedCellIndex();
				// 開始位置から現セル位置までをブロック選択
				this.selectCopyBlock(this.selStRow, this.selStCol, rowIdx, colIdx);
			} else if (code == 16) {
				// Shiftキー押下の場合、現セル位置を開始位置として保持
				var rowId = this.getSelectedRowId();
				if( !rowId ) return false;
				this.selStRow = this.getRowIndex(rowId);
				this.selStCol = this.getSelectedCellIndex();
			}
		}else {
			if(code==27&&this._enableCopyPasteFlg) {
				// ESC: Select Cancel
				this._HideSelection();
				if( this.editor ) {
					this.editStop(true);
				}
			}else if(code==37 || code==38 || code==39 || code==40) {
				// cursor key
				ret = this.processMoveKey(code)
				this._HideSelection();
			}else if(code==46 && !this.editor) {
				// delete key(非セル編集中のみ)
				this.deleteBlock();
			}else {
//				if( !this.editor ) {
//					this.editCell();
//					ret = false;
//				}
			}
		}
		return ret;
	});
}

/**
 * 移動キーの制御
 *
 * @method processMoveKey
 * @param code {number} キーコード
 */
BlenderGrid.prototype.processMoveKey = function(code){
	var ret = true;

	var rowId = this.getSelectedRowId();
	if( !rowId ) return false;
	var rowIdx = this.getRowIndex(rowId);
	var colIdx = this.getSelectedCellIndex();

	if( !this.editor ) {
		if(code==37) {
			// left key
			if( this.leftLinkGrid && colIdx==this.startColIdx ) {
				var leftColIdx = this.leftLinkGrid.endColIdx;
				this.leftLinkGrid.selectCell(rowIdx, leftColIdx, true, true, false, true);
			}else {
				while( this.isColumnHidden(colIdx-1) ) {
					colIdx-=1;
				}
				colIdx = (colIdx>0 ? colIdx-1 : 0);
				if( !this.isColumnHidden(colIdx) ) {
					this.selectCell(rowIdx, colIdx);
				}
			}
		}else if(code==39) {
			// right key
			if( this.rightLinkGrid && colIdx==this.endColIdx ) {
				var rightColIdx = this.rightLinkGrid.startColIdx;
				this.rightLinkGrid.selectCell(rowIdx, rightColIdx, true, true, false, true);
			}else {
				while( this.isColumnHidden(colIdx+1) ) {
					colIdx+=1;
				}
				colIdx = (colIdx<(this.getColumnsNum()-1) ? colIdx+1 : 0);
				while( this.isColumnHidden(colIdx) ) {
					colIdx+=1;
				}
				if( !this.isColumnHidden(colIdx) ) {
					this.selectCell(rowIdx, colIdx);
				}else {
					this.selectCell(rowIdx, 0);
				}
			}
		}else if(code==38) {
			// up key
			if( this.topLinkGrid && rowIdx==0 ) {
				var topRowIdx = (this.topLinkGrid.getRowsNum()-1);
				this.setActive(false);
				this.topLinkGrid.setActive(true);
				this.topLinkGrid.selectCell(topRowIdx, colIdx, true, true, false, true);
			}else {
				this.selectCell(rowIdx-1, colIdx);
			}
		}else if(code==40) {
			// down key
			if( this.bottomLinkGrid && rowIdx==(this.getRowsNum()-1) ) {
				var bottomRowIdx = 0;
				this.setActive(false);
				this.bottomLinkGrid.setActive(true);
				this.bottomLinkGrid.selectCell(bottomRowIdx, colIdx, true, true, false, true);
			}else {
				this.selectCell(rowIdx+1, colIdx);
			}
		}
		ret = false;
	}
	return ret;
}

/**
 * 有効列レンジ(開始列index、終了列index)を更新する。
 *
 * @method updateValidColumnRange
 */
BlenderGrid.prototype.updateValidColumnRange = function(){
	var startColIdx = 0;
	while( this.isColumnHidden(startColIdx) ) {
		startColIdx+=1;
	}
	var endColIdx = this.getColumnsNum()-1;
	while( this.isColumnHidden(endColIdx) ) {
		endColIdx-=1;
	}
	this.startColIdx = startColIdx;
	this.endColIdx   = endColIdx;

	//alert("startColIdx: "+startColIdx+", endColIdx: "+endColIdx);
}

/**
 * CTRL+C/CTRL+Vによるコピー＆ペーストを有効にする。
 * また本メソッドによりブロック選択及びCTRL+Aによるブロック選択も有効になる。
 *
 * @method enableCopyAndPaste
 */
BlenderGrid.prototype.enableCopyAndPaste = function(){
	this._enableCopyPasteFlg = true;
	this.enableBlockSelection(true);
	this.setCSVDelimiter("\t");

	// コピー時の既定動作「テキストのみ」指定時の設定
	if (BlenderGridSettings.FORCE_LABEL_SELECTION){
		this.forceLabelSelection(true);
	}
}

/**
 * 範囲選択の有効無効の設定をする。
 *
 * @method enableBlockSelection
 * @param mode {boolean} 範囲選択の有効無効
 * @override [enableBlockSelection]
 */
BlenderGrid.prototype.enableBlockSelection = function(mode){
	if (typeof this._bs_mode == "undefined"){
		var self = this;
		this.obj.onmousedown = function(e) {
			if (self._bs_mode) self._OnSelectionStart((e||event),this); return true;
		}
		this._CSVRowDelimiter = this.csv.row;
		this.attachEvent("onResize", function() {self._HideSelection(); return true;});
		this.attachEvent("onGridReconstructed", function() {self._HideSelection(); return true;});
		this.attachEvent("onFilterEnd",this._HideSelection);
	}
	if (mode===false){
		this._bs_mode=false;
		return this._HideSelection();
	} else this._bs_mode=true;

	if (!window.dhx4.isIPad){
		var area = this._clip_area = document.createElement("textarea");
		area.style.cssText = "position:absolute; width:1px; height:1px; overflow:hidden; color:transparent; background-color:transparent; bottom:1px; right:1px; border:none;";

		area.onkeydown=function(e){
			e=e||event;
			if (e.keyCode == 86 && (e.ctrlKey || e.metaKey))
				self.pasteBlockFromClipboard()
		};
	    document.body.insertBefore(this._clip_area,document.body.firstChild);

// ヘッダーをクリックした際に、選択データの保存先となる非表示のtextareaを選択状態するが、
// WindowManagerの使用時で、ウインドウがブラウザ画面からはみ出した状態の場合、
// ウインドウがアクティブ状態となり、全部表示されるようにスクロールバーの位置を調整することにより、
// ウインドウが移動されたように感じられるため、スクロールバーの位置が変更されないようにするため、
// クリック時のイベントを動作しないようにコメントアウトする。
// BlenderGridでは、Copy&Pasteの処理をオーバライドしており、該当するtextareaを使用していないため影響はない。
//	    dhtmlxEvent(this.entBox,"click",function(){
//			if (!self.editor && self._clip_area) {
//				self._clip_area.select();
//			}
//	    });
	}
}

/**
 * クリップボードにコピーする。
 * スマートレンダリング対応版。
 *
 * @method copyBlockToClipboard
 */
BlenderGrid.prototype.copyBlockToClipboard = function() {
	if ( this._selectionArea != null ){
		var serialized = new Array();
		if (this._mathSerialization)
			this._agetm="getMathValue";
		else if (this._strictText)
			this._agetm="getTitle";
		else this._agetm="getValue";
		// _agetmは、本来_serializeRowToCVS()で使用されるが、blenderでは使用しない

		var min=this._selectionArea.LeftTopRow;
		var max=this._selectionArea.RightBottomRow;
		this._update_srnd_view_pos(min,max);

		var startRow = this._selectionArea.LeftTopRow;
		var startCol = this._selectionArea.LeftTopCol;
		var endRow   = this._selectionArea.RightBottomRow;
		var endCol   = this._selectionArea.RightBottomCol;

		if (this.pagingOn && this.currentPage > 1) {
			startRow = startRow % this.rowsBufferOutSize;
			endRow = endRow % this.rowsBufferOutSize;
		}

		//alert(startRow+", "+startCol+" - "+endRow+", "+endCol);

		var startRightCell = this.cells2(startRow, endCol);
		var endCell = this.cells2(endRow, endCol);

		endRow += endCell.cell.rowSpan;

		var tmpIdx = endCol+1;
		if( startRightCell.cell.colSpan>1 ) {
			if( startRightCell.cell._cellIndex+startRightCell.cell.colSpan>tmpIdx ) {
				tmpIdx = startRightCell.cell._cellIndex+startRightCell.cell.colSpan;
			}
		}
		if( endCell.cell.colSpan>1 ) {
			if( endCell.cell._cellIndex+endCell.cell.colSpan>tmpIdx ) {
				tmpIdx = endCell.cell._cellIndex+endCell.cell.colSpan;
			}
		}
		endCol = tmpIdx;

		//alert(startRow+", "+startCol+" - "+endRow+", "+endCol);

		for (var i=startRow; i<endRow; i++){
			var data = this._serializeRowToCVS(this.rowsCol[i], null, startCol, endCol);
			if (!this._csvAID)
				serialized[serialized.length] = data.substr( data.indexOf( this.csv.cell ) + 1 );
			else
				serialized[serialized.length] = data
		};

		serialized = serialized.join(this._CSVRowDelimiter);
		this.toClipBoard(serialized)
	}
};

/**
 * 行データをCSVデータにシリアライズする。
 * この際、データ取得には標準の getValue ではなく、getText を利用する。
 *
 * @method _serializeRowToCVS
 * @param r {number}
 * @param i {number}
 * @param start {number} 開始列
 * @param end {number} 終了列
 * @private
 */
BlenderGrid.prototype._serializeRowToCVS = function(r,i,start,end){
	var out = new Array();
	if (!r){
		r=this.render_row(i)
		if (this._fake && !this._fake.rowsAr[r.idd])
			this._fake.render_row(i)
	};
	if (!this._csvAID)
		out[out.length]=r.idd;

	start = start||0;
	end = end||this._cCount;
	var changeFl=false;
	var ind=start;

	if( r.childNodes.length <= start ) {
		start = r.childNodes.length -1;
	}
	while (r.childNodes[start]._cellIndex>ind && start)
		start--;

	for(var jj=start;ind<end;jj++){
		if (!r.childNodes[jj])
			break;

		var real_ind=r.childNodes[jj]._cellIndex;

		if( this.isColumnHidden(real_ind) ) {
			ind++;
			continue;
		}

		if ((!this._srClmn)||(this._srClmn[real_ind])){
			var cvx=r.childNodes[jj];
			var zx=this.cells(r.idd,real_ind);
			while (ind!=real_ind){
				ind++;
				out.push("")
				if (ind>=end) break
			};

			if (ind>=end) break;
			ind++;

//			if (zx.cell){
			if (zx.cell && !zx.cell._clearCell){
//				zxVal=zx[this._agetm]();
				if (this._strictText){
					zxVal=zx["getStrictText"]();
				}else {
					zxVal=zx["getText"]();
				}
			}else {
				zxVal="";
			}

			if ((this._chAttr)&&(zx.wasChanged()))
				changeFl=true;

			out[out.length]=((zxVal===null)?"":zxVal);
			if ( this._ecspn && cvx.colSpan && cvx.colSpan >1 ){
				cvx=cvx.colSpan-1;
				for (var u=0;u<cvx;u++)
					out[out.length] = "";
				ind++;
			}
		}else ind++;
	};

	if ((this._onlChAttr)&&(!changeFl)) return "";

	return out.join(this.csv.cell);
};

/**
 * クリップボードからペーストする。
 * スマートレンダリング対応版。
 *
 * @method pasteBlockFromClipboard
 */
BlenderGrid.prototype.pasteBlockFromClipboard = function() {
	var serialized = this.fromClipBoard();
	if( serialized === null || serialized === undefined ) return;

	serialized = serialized.split(this._CSVRowDelimiter);
//	serialized = this.csvParser.unblock(serialized, this.csv.cell, this.csv.row);
	if ((serialized.length >1)&&(serialized[serialized.length-1]==""))
		serialized.splice(serialized.length-1,1);

	for (var i=0;i<serialized.length;i++){
		serialized[i] = new String(serialized[i]).replace(/\r/g,"");
		serialized[i] = serialized[i].split(this.csv.cell)
	};

	var startRow;
	var startCol;
	var endRow;
	var endCol;
	var repeatFlg = false;

	if (this._selectionArea != null){
		// 選択範囲存在アリ
		startRow = this._selectionArea.LeftTopRow;
		startCol = this._selectionArea.LeftTopCol;
		endRow   = this._selectionArea.RightBottomRow+1;
		endCol   = this._selectionArea.RightBottomCol+1;
	}else if (this.cell != null && !this.editor){
		// 選択範囲存在ナシ
		startRow = this.getRowIndex( this.cell.parentNode.idd );
		startCol = this.cell._cellIndex;
		//endRow = startRow+serialized.length;
		endRow = (this.cell.rowSpan>=serialized.length ? startRow+1 : startRow+serialized.length);
		//endCol = startCol+serialized[0].length;
		//endCol = this.calcPastEndColIdx(startCol, serialized[0].length);
		endCol = (this.cell.colSpan>=serialized[0].length ? startCol+1 : this.calcPastEndColIdx(startCol, serialized[0].length));
	}else {
		return false
	};

	// 選択範囲拡張(サイズ1の場合、コピー元データにあわせ拡張)
	if( (endRow-startRow)==1 ) {
		endRow = startRow+serialized.length;
	}
	if( (endCol-startCol)==1 ) {
		//endCol = startCol+serialized[0].length;
		endCol = this.calcPastEndColIdx(startCol, serialized[0].length);
	}

	//debug("("+startRow+","+startCol+") - ("+endRow+","+endCol+")");

	// 範囲が整数倍の場合、Repert コピー実施。
	// 範囲が整数倍ではない場合、１データのみコピーを実施。
	if( ((endRow-startRow)%serialized.length==0
	 && this.countShowColsNum(startCol,endCol)%serialized[0].length==0) ) {
		//debug("ペースト範囲:整数倍");
		repeatFlg = true;
	}else {
		//debug("ペースト範囲:非整数倍");
		endRow = startRow+serialized.length;
		//endCol = startCol+serialized[0].length;
		endCol = this.calcPastEndColIdx(startCol, serialized[0].length);
	}

	if (endRow > this.rowsBuffer.length)
		endRow = this.rowsBuffer.length;
	if (endCol > this._cCount)
		endCol = this._cCount;

	//alert("("+startRow+","+startCol+") - ("+endRow+","+endCol+")");

	var min=startRow;
	var max=endRow;
	this._update_srnd_view_pos(min,max);

	var k;

	// ペーストデータと元データを比較し変更の有無を確認。
	var findModify = false;
	k = 0;
	for (var i=startRow;i<endRow;i++){
		var row = this.render_row(i);
		if (row==-1) continue;

//		var l = 0;
		for (var j=0;j<this.getColumnsNum();j++){
			if( this.isColumnHidden(j) ) {
				continue;
			}

			var ed = this.cells3(row, j);
			var realIndex = ed.cell._cellIndex;
			var dtIndex = ((realIndex - startCol) % serialized[0].length);

			if( realIndex<startCol || endCol<=realIndex ){
				continue;
			}

			if (ed.isDisabled()) {
//				l++;
				continue
			};

			if( ed.getText()!=serialized[ k ][ dtIndex ] ) {
				findModify = true;
			}
//			if( repeatFlg && l>=serialized[0].length ) {
//				l=0;
//			}
		};
		k++;
		if( repeatFlg && k>=serialized.length ) {
			k=0;
		}
	};

	if( !findModify ) {
		// 変更なしの場合はNOP
		return;
	}

	var undoCmdArray = [];
	var dirty_flag = this.isDirty();

	// ペースト実施。隠しカラムがある場合はスキップ。
	k = 0;
	for (var i=startRow;i<endRow;i++){
		var row = this.render_row(i);
		if (row==-1) continue;

		var cmds = new Array(endCol-startCol);

		var pasteColIdxes = new Array();

//		var l = 0;
		for (var j=0;j<this.getColumnsNum();j++){
			if( this.isColumnHidden(j) ) {
				continue;
			}

			var ed = this.cells3(row, j);
			var realIndex = ed.cell._cellIndex;
			var dtIndex = ((realIndex - startCol) % serialized[0].length);

			if( realIndex<startCol || endCol<=realIndex ){
				continue;
			}

			if (ed.isDisabled()) {
//				l++;
//				if( repeatFlg && l>=serialized[0].length ) {
//					l=0;
//				}
				continue
			};

			pasteColIdxes.push(j);

			//alert("l: "+l+", colspan: "+ed.cell.colSpan+", rowspan: "+ed.cell.rowSpan);
			var step = (ed.cell.colSpan ? ed.cell.colSpan : 1);

			var cmd = new BlenderGridEditCommand(this, row.idd, j);
			cmd.old_value = ed.getValue();
			cmd.old_textColor = ed.getTextColor();
			cmd.old_className = ed.cell.className.replace(/cellselected/g, "");
			cmd.old_change_flag = ed.cell.wasChanged;
			cmd.old_dirty_flag = dirty_flag;
			cmds[j-startCol] = cmd;

			undoCmdArray[undoCmdArray.length] = cmd;

			if (ed.combo){
				var comboVa = ed.combo.values;
				for(var n=0;n<comboVa.length;n++)
					if (serialized[ k ][ dtIndex ] == comboVa[n]){
						ed.setValue( ed.combo.keys[ n ] );
						comboVa=null;
						break
					};
				if (comboVa!=null)
					ed.setValue( serialized[ k ][ dtIndex ] );
			}else {
				ed[ ed.setImage ? "setLabel" : "setValue" ]( serialized[ k ][ dtIndex ] );
			}

			ed.cell.wasChanged=true;

			if (ed.cell._cellType=="bl_co") {
				this.callEvent("onEditCell", [ 2, row.idd, j, ed.combo.keys[ n ], cmd.old_value ]);
			}

			if (this.getColType(j)=="bl_ch") {
				this.callEvent("onCheckbox", [row.idd, j, (ed.getValue() == '1') ]);
				this.callEvent("onCheck", [row.idd, j, (ed.getValue() == '1') ])
			}

			//l++;
//			l=l+step;
			j=j+(step-1); // for文で進める分を1戻す

//			if( repeatFlg && l>=serialized[0].length ) {
//				l=0;
//			}
		};

		this.callEvent("onRowPaste",[row.idd, pasteColIdxes])

		// 編集後に決定された文字色、CSSクラスその他のフラグ等を
		// Undoコマンドに反映させる。
//		var l = 0;
		for (var j=0;j<this.getColumnsNum();j++){
			if( this.isColumnHidden(j) ) {
				continue;
			}

			var ed = this.cells3(row, j);
			var realIndex = ed.cell._cellIndex;
			var dtIndex = ((realIndex - startCol) % serialized[0].length);

			if( realIndex<startCol || endCol<=realIndex ){
				continue;
			}

			if (ed.isDisabled()) {
//				l++;
//				if( repeatFlg && l>=serialized[0].length ) {
//					l=0;
//				}
				continue
			};

			var step = (ed.cell.colSpan ? ed.cell.colSpan : 1);

			var cmd = cmds[j-startCol];
			cmd.new_value = ed.getValue(); // serialized[ k ][ l ];
			cmd.new_textColor = ed.getTextColor();
			cmd.new_className = ed.cell.className.replace(/cellselected/g, "");
			cmd.new_change_flag = ed.cell.wasChanged;
			cmd.new_dirty_flag = this.isDirty();

//			l=l+step;
			j=j+(step-1); // for文で進める分を1戻す

//			if( repeatFlg && l>=serialized[0].length ) {
//				l=0;
//			}
		};

		k++;
		if( repeatFlg && k>=serialized.length ) {
			k=0;
		}
	}

	// Undo有効ならバッファにpush
	if (this._IsUndoRedoEnabled) {
		this._pushUndoBuffer(undoCmdArray);
	}

	//alert("("+startRow+","+startCol+") - ("+(endRow-1)+","+(endCol-1)+")");

	this.selectCopyBlock(startRow,startCol,endRow-1,endCol-1);
};

/**
 * 選択範囲を削除する。
 *
 * @method calcPastEndColIdx
 * @param startCol {number} 開始カラムindex
 * @param csvColsNum {number} CSVデータカラム数
 * @return 指定CSVデータをペーストする際の終了カラムindex
 */
BlenderGrid.prototype.calcPastEndColIdx = function(startCol,csvColsNum) {
	var ret = startCol;

	var num = 0;
	for( var i=startCol; i<this.getColumnsNum(); i++ ) {
		if( this.isColumnHidden(i) ) {
			continue;
		}
		ret=i;
		num++;

		if( num>=csvColsNum ) {
			break;
		}
	}
	return ret+1;
};

/**
 * 表示中カラムの数を数える。
 *
 * @method countShowColsNum
 * @param startCol {number} 開始カラムindex
 * @param endCol {number} 終了カラムindex
 * @return 指定範囲内の表示カラム数
 */
BlenderGrid.prototype.countShowColsNum = function(startCol,endCol) {
	var ret = 0;
	for( var i=startCol; i<endCol; i++ ) {
		if( this.isColumnHidden(i) ) {
			continue;
		}
		ret++;
	}
	return ret;
};

/**
 * 選択範囲を削除する。
 * スマートレンダリング対応版。
 *
 * @method deleteBlock
 */
BlenderGrid.prototype.deleteBlock = function() {
	var startRow;
	var startCol;
	var endRow;
	var endCol;

	if (this._selectionArea != null){
		startRow = this._selectionArea.LeftTopRow;
		startCol = this._selectionArea.LeftTopCol;
		endRow   = this._selectionArea.RightBottomRow+1;
		endCol   = this._selectionArea.RightBottomCol+1;
	}else if (this.cell != null && !this.editor){
		startRow = this.getRowIndex( this.cell.parentNode.idd );
		startCol = this.cell._cellIndex;
		endRow   = startRow+1;
		endCol   = startCol+1;
	}else {
		return false
	};

	//alert("startRow: "+startRow+", startCol: "+startCol+", endRow: "+endRow+", endCol: "+endCol)

	if (endRow > this.rowsBuffer.length)
		endRow = this.rowsBuffer.length;
	if (endCol > this._cCount)
		endCol = this._cCount;

	var min=startRow;
	var max=endRow;
	this._update_srnd_view_pos(min,max);

	var undoCmdArray = [];

	var dirty_flag = this.isDirty();

	var findModify = false;
	for (var i=startRow;i<endRow;i++){
		var row = this.render_row(i);
		if (row==-1) continue;
		for (var j=startCol;j<endCol;j++){
			var ed = this.cells3(row, j);
			if (ed.isDisabled()) {
				continue
			};
			if( ed.getValue()!==null && ed.getValue()!=="" ) {
				findModify = true;
			}
		};
	};

	if( !findModify ) {
		return;
	}

	for (var i=startRow;i<endRow;i++){
		var row = this.render_row(i);
		if (row==-1) continue;

		var cmds = new Array(endCol-startCol);

		var pasteColIdxes = new Array();

		for (var j=startCol;j<endCol;j++){
			var ed = this.cells3(row, j);
			if (ed.isDisabled()) {
				continue
			};

			pasteColIdxes.push(j);

			var cmd = new BlenderGridEditCommand(this, row.idd, j);
			cmd.old_value = ed.getValue();
			cmd.old_textColor = ed.getTextColor();
			cmd.old_className = ed.cell.className.replace(/cellselected/g, "");
			cmd.old_change_flag = ed.cell.wasChanged;
			cmd.old_dirty_flag = dirty_flag;
			cmds[j-startCol] = cmd;

			undoCmdArray[undoCmdArray.length] = cmd;

			if (ed.combo){
				var comboVa = ed.combo.values;
				for(var n=0;n<comboVa.length;n++)
					if ("" == comboVa[n]){
						ed.setValue( ed.combo.keys[ n ]);
						comboVa=null;
						break
					};
				if (comboVa!=null)
					ed.setValue( "" )
			}else {
				ed[ ed.setImage ? "setLabel" : "setValue" ]( "" );
			}

			if (this.getColType(j)=="bl_ch") {
				this.callEvent("onCheckbox", [row.idd, j, (ed.getValue() == '1') ]);
				this.callEvent("onCheck", [row.idd, j, (ed.getValue() == '1') ])
			}

			ed.cell.wasChanged=true;
		};

		this.callEvent("onRowPaste",[row.idd, pasteColIdxes])

		for (var j=startCol;j<endCol;j++){
			var ed = this.cells3(row, j);
			if (ed.isDisabled()) {
				continue
			};

			var cmd = cmds[j-startCol];
			cmd.new_value = "";
			cmd.new_textColor = ed.getTextColor();
			cmd.new_className = ed.cell.className.replace(/cellselected/g, "");
			cmd.new_change_flag = ed.cell.wasChanged;
			cmd.new_dirty_flag = this.isDirty();
		};
	}

	if (this._IsUndoRedoEnabled) {
		this._pushUndoBuffer(undoCmdArray);
	}

	this.selectCopyBlock(startRow,startCol,endRow-1,endCol-1);
};

/**
 * ブロックエリアを選択する。
 *
 * @method selectCopyBlock
 * @param startRowIdx {number} 開始行インデックス
 * @param startColIdx {number} 開始列インデックス
 * @param endRowIdx {number} 終了行インデックス
 * @param endColIdx {number} 終了列インデックス
 */
BlenderGrid.prototype.selectCopyBlock = function(startRowIdx,startColIdx,endRowIdx,endColIdx) {
	var startRowId=this.getRowId(startRowIdx);
	var endRowId=this.getRowId(endRowIdx);

	this.selectCopyBlock2(startRowId,startColIdx,endRowId,endColIdx);
}

/**
 * ブロックエリアを選択する。
 *
 * @method selectCopyBlock2
 * @param startRowId {string} 開始行Id
 * @param startColIdx 開始列インデックス
 * @param endRowId 終了行Id
 * @param endColIdx 終了列インデックス
 */
BlenderGrid.prototype.selectCopyBlock2 = function(startRowId,startColIdx,endRowId,endColIdx) {
	if( !startRowId || !endRowId ) {
		return;
	}

	if( endColIdx < startColIdx ) {
		var tmp = startColIdx;
		startColIdx = endColIdx;
		endColIdx = tmp;
	}

	var i;
	for( i=startColIdx; i<=endColIdx; i++ ) {
		if( !this.isColumnHidden(i) ) {
			break;
		}
	}
	startColIdx = i;
	for( i=endColIdx; i>=startColIdx; i-- ) {
		if( !this.isColumnHidden(i) ) {
			break;
		}
	}
	endColIdx = i;

	//alert("("+startRowId+","+startColIdx+") - ("+endRowId+","+endColIdx+")");

	var startCell = this.cellsv(startRowId,startColIdx);
	var endCell = this.cellsv(endRowId,endColIdx);

	this._selectionArea = this._RedrawSelectionPos(
		startCell.cell,
		endCell.cell
	);

	this._ShowSelection();
}

/**
 * 行を選択する。
 *
 * @method selectCopyLine
 * @param rowId {string} 行Id
 */
BlenderGrid.prototype.selectCopyLine = function(rowId){
	if( !rowId ) return;

	var endColIdx = this.getColumnsNum()-1;

	this.selectCopyBlock2(rowId,0,rowId,endColIdx);
}

/**
 * ブロックエリアを描画する。(ブロックエリアサイズ調整版)
 *
 * @method _RedrawSelectionPos
 * @param LeftTop 左上セル
 * @param RightBottom 右下セル
 */
BlenderGrid.prototype._RedrawSelectionPos = function(LeftTop, RightBottom) {
	if( LeftTop.parentNode.parentNode.parentNode.grid.tagId
	 != RightBottom.parentNode.parentNode.parentNode.grid.tagId ) {
		return;
	}

	var pos = {
	};
	pos.LeftTopCol = LeftTop._cellIndex;
	pos.LeftTopRow = this.getRowIndex( LeftTop.parentNode.idd );
	pos.RightBottomCol = RightBottom._cellIndex;
	pos.RightBottomRow = this.getRowIndex( RightBottom.parentNode.idd );

	if( null!=LeftTop.cell && LeftTop.cell.colSpan>1 ) {
		pos.LeftTopCol += LeftTop.cell.colSpan;
	}
	if( null!=RightBottom.cell && RightBottom.cell.colSpan>1 ) {
		pos.RightBottomCol += RightBottom.cell.colSpan;
	}

	var tmpCell = this.cells2(pos.LeftTopRow, RightBottom._cellIndex);
	if( tmpCell.cell.colSpan>1 ) {
		if( tmpCell.cell._cellIndex+tmpCell.cell.colSpan>pos.RightBottomCol ) {
			pos.RightBottomCol = tmpCell.cell._cellIndex+tmpCell.cell.colSpan-1;
		}
	}

	var LeftTop_width = LeftTop.offsetWidth;
	var LeftTop_height = LeftTop.offsetHeight;
	LeftTop = this.getPosition(LeftTop, this.obj);

	var RightBottom_width = RightBottom.offsetWidth;
	var RightBottom_height = RightBottom.offsetHeight;
	RightBottom = this.getPosition(RightBottom, this.obj);

	if (LeftTop[0] <= RightBottom[0]){
		var Left = LeftTop[0];
		var Right = RightBottom[0] + RightBottom_width
	}else {
		var foo = pos.RightBottomCol;
		pos.RightBottomCol = pos.LeftTopCol;
		pos.LeftTopCol = foo;
		var Left = RightBottom[0];
		var Right = LeftTop[0] + LeftTop_width;
	};
	if (LeftTop[1] <= RightBottom[1]){
		var Top = LeftTop[1];
		var Bottom = RightBottom[1] + RightBottom_height
	}else {
		var foo = pos.RightBottomRow;
		pos.RightBottomRow = pos.LeftTopRow;
		pos.LeftTopRow = foo;
		var Top = RightBottom[1];
		var Bottom = LeftTop[1] + LeftTop_height;
	};

	var tmpIdx;
	do {
		tmpIdx = pos.LeftTopCol;
		for ( var i = pos.LeftTopRow; i <= pos.RightBottomRow; i++) {
			var tempCell = this.cells2(i, pos.LeftTopCol);
			if(tempCell.cell._cellIndex < pos.LeftTopCol){
				pos.LeftTopCol = tempCell.cell._cellIndex;
				var tempCell = this.getPosition(tempCell.cell, this.obj);
				var Left = tempCell[0];
			}
		}
	} while (tmpIdx != pos.LeftTopCol);

	do {
		tmpIdx = pos.RightBottomCol;
		for ( var i = pos.LeftTopRow; i <= pos.RightBottomRow; i++) {
			var tempCell = this.cells2(i, pos.RightBottomCol);
			if(1 < tempCell.cell.colSpan){
				pos.RightBottomCol = tempCell.cell._cellIndex + tempCell.cell.colSpan - 1;
				var width = tempCell.cell.offsetWidth;
				var tempCell = this.getPosition(tempCell.cell, this.obj);
				var Right = tempCell[0] + width;
			}
		}
	} while (tmpIdx != pos.RightBottomCol);

	if( !this._selectionObj ) {
		this._CreateSelection(0,0);
	}

	//console.log("top: "+Top+", bottom: "+Bottom+", Right: "+Right+", Left: "+Left);

	var Width = (Right - Left -1);
	if( Width<0 ) Width = 0;
	var Height = Bottom - Top;
	if( Height<0 ) Height = 0;

	this._selectionObj.style.left = (Left-1) + 'px';
	this._selectionObj.style.top = (Top-1) + 'px';
	this._selectionObj.style.width = Width + 'px';
	this._selectionObj.style.height = Height + 'px';
	return pos
};

/**
 * Undo処理を行う。
 * ブロックペースト対応版。
 * (CTRL+Z)キーに対応。
 *
 * @method doUndo
 */
BlenderGrid.prototype.doUndo = function() {
	// NOP
};

/**
 * Redo処理を行う。
 * ブロックペースト対応版。
 * (CTRL+Y)キーに対応。
 *
 * @method doRedo
 */
BlenderGrid.prototype.doRedo = function() {
	// NOP
};

/**
 * 選択エリアを作成する。
 * @method _CreateSelection
 * @param x X座標
 * @param y Y座標
 */
BlenderGrid.prototype._CreateSelection = function(x, y) {
	var self = this;
	if (this._selectionObj == null){
		var div = document.createElement('div');
		div.style.position = 'absolute';
		div.style.display = 'none';
		div.className = 'dhtmlxGrid_selection';
		this._selectionObj = div;
		this._selectionObj.onmousedown = function(e){
			e=e||event;
			if (isBtnLeft(e.button) || (_isMacOS&&(!e.ctrlKey))) {
				return this.parentNode.grid.callEvent("onBlockLeftClick", ["BLOCK",e]);
			}else if (e.button==2 || (_isMacOS&&e.ctrlKey)) {
				return this.parentNode.grid.callEvent("onBlockRightClick", ["BLOCK",e]);
			}
		};
		this._selectionObj.oncontextmenu=function(e){
			var grid = this.parentNode.grid;
			var ev = {};
			$.extend(ev, e);
			ev["srcElement"] = grid._endSelectionCell;
			ev["target"] = grid._endSelectionCell;
			return this.parentNode.grid._doContClick(ev);
		};
		this.objBox.appendChild(this._selectionObj)
	};
	var self = this;
	this._selectionObj.onmousemove = function(e) {
		e = e||event;
		if (isBtnLeft(e.button) || (_isMacOS&&(!e.ctrlKey))) {
			e.returnValue = false;
			self._OnSelectionMove(e);
		}
	};
	this._selectionObj.style.width = '0px';
	this._selectionObj.style.height = '0px';
	this._selectionObj.style.left = x + 'px';
	this._selectionObj.style.top = y + 'px';
	this._selectionObj.startX = x;
	this._selectionObj.startY = y
};

/**
 * 選択エリアを表示する。
 * @method _ShowSelection
 */
BlenderGrid.prototype._ShowSelection = function() {
	var g;
	g = this.leftLinkGrid;
	while( g && g!=this ) {
		g._HideSelection();
		g.clearSelection();
		g = g.leftLinkGrid;
	}
	g = this.rightLinkGrid;
	while( g && g!=this ) {
		g._HideSelection();
		g.clearSelection();
		g = g.rightLinkGrid;
	}

	if (this._selectionObj) this._selectionObj.style.display = '';
};

/**
 * 範囲選択を開始する。
 *
 * @method _OnSelectionStart
 * @param event イベント
 * @param obj 対象オブジェクト
 */
BlenderGrid.prototype._OnSelectionStart = function(event, obj) {
	var self = this;
	if (event.button == 2)
		return;
	var src = event.srcElement || event.target;
	if (this.editor){
		//if (src.tagName && (src.tagName=="INPUT" || src.tagName=="TEXTAREA"))
		if (src.tagName && (src.tagName=="INPUT" || src.tagName=="TEXTAREA" || src.tagName=="DIV"))
			return;
		this.editStop()
	};

	self.setActive(true);
	var pos = this.getPosition(this.obj);
	var x = event.clientX - pos[0] + (document.body.scrollLeft||(document.documentElement?document.documentElement.scrollLeft:0));
	var y = event.clientY - pos[1] + (document.body.scrollTop||(document.documentElement?document.documentElement.scrollTop:0));

	if( event.shiftKey ){
		// shiftクリックされた場合は、現在の選択セルを開始位置、
		// クリック位置を終了位置として範囲選択する。
		var rowId = self.getSelectedRowId();
		if( !rowId ) return false;
		var sRowIdx = self.getRowIndex(rowId);
		var sColIdx = self.getSelectedCellIndex();

		var endCell = self._getCellByPos(x, y);
		var eRowIdx = self.getRowIndex(endCell.parentNode.idd);
		var eColIdx = endCell._cellIndex;

		self.selectCopyBlock(sRowIdx, sColIdx, eRowIdx, eColIdx);
		return;
	}

	this._CreateSelection(x-4, y-4);
	if (src == this._selectionObj){
		this._HideSelection();
		this._startSelectionCell = null
	}else {
		while (null!=src && null!=src.tagName && src.tagName.toLowerCase()!= 'td')
			src = src.parentNode;
		this._startSelectionCell = src
	};
	if (this._startSelectionCell){
		if (!this.callEvent("onBeforeBlockSelected",[this._startSelectionCell.parentNode.idd, this._startSelectionCell._cellIndex]))
			return this._startSelectionCell = null;
	}

	this.obj.onmousedown = null;
	this.obj[_isIE?"onmouseleave":"onmouseout"] = function(e){
		if (self._blsTimer)
			window.clearTimeout(self._blsTimer)
	};
	this.obj.onmmold=this.obj.onmousemove;
	this._init_pos=[x,y];
	this._selectionObj.onmousemove = this.obj.onmousemove = function(e) {
		e = e||event;
		if (e.preventDefault) e.preventDefault();
		else e.returnValue = false;
		self._OnSelectionMove(e);
	};
	this._oldDMP=document.body.onmouseup;
	document.body.onmouseup = function(e) {
		e = e||event;
		self._OnSelectionStop(e, this);
		return true;
	};
	document.body.onselectstart = function(){
		return false
	}
};

/**
 * 座標からセルを取得する。
 *
 * @method _getCellByPos
 * @param x x軸
 * @param y y軸
 */
BlenderGrid.prototype._getCellByPos = function(x,y){
	x=x;//+this.objBox.scrollLeft;
	if (this._fake)
		x+=this._fake.objBox.scrollWidth;
	y=y;//+this.objBox.scrollTop;
	var _x=0;
	for (var i=0; i < this.obj.rows.length; i++) {
		y-=this.obj.rows[i].offsetHeight;
		if (y<=0) {
			_x=this.obj.rows[i];
			break;
		}
	}
	if (!_x || !_x.idd) return null;
	for (var i=0; i < this._cCount; i++) {
		x-=this.getColWidth(i);
		if (x<=0) {
//			while(true){
//				if (_x._childIndexes && _x._childIndexes[i+1]==_x._childIndexes[i])
//					_x=_x.previousSibling;
//				else {
					return this.cells(_x.idd,i).cell;
//				}
//
//			}
		}
	}
	return null;
}

/**
 * 範囲選択を移動する。
 *
 * @method _OnSelectionMove
 * @param event {event} イベント
 */
BlenderGrid.prototype._OnSelectionMove = function(event) {
	var self=this;

	this._ShowSelection();
	var pos = this.getPosition(this.obj);
	var X = event.clientX - pos[0] + (document.body.scrollLeft||(document.documentElement?document.documentElement.scrollLeft:0));
	var Y = event.clientY - pos[1] + (document.body.scrollTop||(document.documentElement?document.documentElement.scrollTop:0));

	if ((Math.abs(this._init_pos[0]-X)<5) && (Math.abs(this._init_pos[1]-Y)<5)) return this._HideSelection();

	if(this._startSelectionCell==null)
		this._endSelectionCell = this._startSelectionCell
		 = this.getFirstParentOfType(event.srcElement || event.target,"TD");
	else if (event.srcElement || event.target){
		if ((event.srcElement || event.target).className == "dhtmlxGrid_selection") {
			this._endSelectionCell=(this._getCellByPos(X,Y)||this._endSelectionCell);
//			this._endSelectionCell=this._endSelectionCell;
		}else {
			var t = this.getFirstParentOfType(event.srcElement || event.target,"TD");
			if (t.parentNode.idd)this._endSelectionCell = t
		}
	};

/* AUTO SCROLL */
	var BottomRightX = this.objBox.scrollLeft + this.objBox.clientWidth;
	var BottomRightY = this.objBox.scrollTop + this.objBox.clientHeight;
	var TopLeftX = this.objBox.scrollLeft;
	var TopLeftY = this.objBox.scrollTop;

	var nextCall=false;
	if (this._blsTimer) window.clearTimeout(this._blsTimer);

	if (X+20 >= BottomRightX) {
		this.objBox.scrollLeft = this.objBox.scrollLeft+20;
		nextCall=true;
	} else if (X-20 < TopLeftX) {
		this.objBox.scrollLeft = this.objBox.scrollLeft-20;
		nextCall=true;
	}
	if (Y+20 >= BottomRightY && !this._realfake) {
		this.objBox.scrollTop = this.objBox.scrollTop+20;
		nextCall=true;
	} else if (Y-20 < TopLeftY && !this._realfake) {
		this.objBox.scrollTop = this.objBox.scrollTop-20;
		nextCall=true;
	}
	this._selectionArea = this._RedrawSelectionPos(this._startSelectionCell, this._endSelectionCell);

	if (nextCall){
		var a=event.clientX;
		var b=event.clientY;
		this._blsTimer=window.setTimeout(function(){self._OnSelectionMove({clientX:a,clientY:b})},100);
	}
};

/**
 * 範囲選択を終了する。
 *
 * @method _OnSelectionStop
 * @param event {event} イベント
 */
BlenderGrid.prototype._OnSelectionStop = function(event) {
	var self = this;
	if (this._blsTimer)window.clearTimeout(this._blsTimer);

	this.obj.onmousedown = function(e) {
		if (self._bs_mode) self._OnSelectionStart((e||event), this);
		return true
	};

	this.obj.onmousemove = this.obj.onmmold||null;
	this._selectionObj.onmousemove = null;

	document.body.onmouseup = this._oldDMP||null;

	if ( parseInt( this._selectionObj.style.width )< 2 && parseInt( this._selectionObj.style.height ) < 2) {
		this._HideSelection()
	}else {
		var src = this.getFirstParentOfType(event.srcElement || event.target,"TD");
		if ((!src)|| (!src.parentNode.idd)){
			src=this._endSelectionCell
		};
		if (!src) return this._HideSelection();
		while (src.tagName.toLowerCase()!= 'td')
			src = src.parentNode;
		this._stopSelectionCell = src;
		this._selectionArea = this._RedrawSelectionPos(this._startSelectionCell, this._stopSelectionCell);
		this.callEvent("onBlockSelected",[])
	};
	document.body.onselectstart = function(){
	}
};

/**
 * 全選択を実施する。
 *
 * @method selectedAll
 */
BlenderGrid.prototype.selectedAll=function(){
	var rowsNum = this.getRowsNum();
	var topRow = 0;
	var bottomRow = rowsNum - 1;
	if (this.pagingOn) {
		topRow = (this.currentPage - 1)  * this.rowsBufferOutSize;
		if ((parseInt(this.getRowsNum()/this.rowsBufferOutSize) + 1) != this.currentPage) {
			bottomRow = this.currentPage * this.rowsBufferOutSize - 1;
			rowsNum = this.rowsBufferOutSize;
		} else {
			rowsNum = rowsNum % this.rowsBufferOutSize;
		}
	}
	this._update_srnd_view_pos(0,rowsNum);
	this.selectCopyBlock(topRow,0,bottomRow,this.getColumnsNum()-1);
};

/**
 * UndoバッファにUndoオブジェクト(コマンド)を追加する。
 *
 * @method _pushUndoBuffer
 * @param undoObj Undoオブジェクト(コマンド)
 */
BlenderGrid.prototype._pushUndoBuffer = function(undoObj) {
	// NOP
};

/**
 * スマートレンダリングビューを更新する。
 *
 * @method _update_srnd_view
 */
BlenderGrid.prototype._update_srnd_view=function(){
	var min=Math.floor(this.objBox.scrollTop/this._srdh);
	var max=min+this._get_view_size();//+10; // +10:magic num

	if (this.multiLine){
		var pxHeight = this.objBox.scrollTop;
		min = 0;
		while(pxHeight > 0){
			pxHeight-=this.rowsCol[min] ? this.rowsCol[min].offsetHeight : this._srdh;
			min++
		};
		max=min+this._get_view_size();
		if (min>0)min--
	};
	max+=(this._srnd_pr||0);

	if (this.rowsBuffer.length-max < this._srdh)
		max=this.rowsBuffer.length;

	this._update_srnd_view_pos(min,max);
};

/**
 * 指定範囲内のスマートレンダリングビューを更新する。
 *
 * @method _update_srnd_view_pos
 * @param min {number} 最小位置
 * @param max {number} 最大位置
 */
BlenderGrid.prototype._update_srnd_view_pos=function(min,max){
	// スマートレンダラー無効時は、処理しない。
	if(!this._srnd) return;
	if (max>this.rowsBuffer.length)
		max=this.rowsBuffer.length;

	// 画面表示範囲外も先読みで描写
	// (THRESHOLD = 1の場合は、表示範囲が30行であれば、前30行、後30行の合計90行描写する）
	var THRESHOLD = 1.0
	var len = Math.ceil((max - min) * THRESHOLD);
	var st = Math.max(0, min - len);
	var en = Math.min(this.rowsBuffer.length, max + len);
	for (var j=st; j<en; j++){
		if (!this.rowsCol[j]){
			var res=this._add_from_buffer(j);

				if (res==-1){
					if (this.xmlFileUrl){
						if (this._dpref && this.rowsBuffer[max-1]){
							//we have last row in sett, assuming that we in scrolling up process
							var rows_count = this._dpref?this._dpref:(max-j)
							var start_pos = Math.max(0, Math.min(j, max - this._dpref));
							this._current_load=[start_pos, max-start_pos];
						} else
							this._current_load=[j,(this._dpref?this._dpref:(max-j))];
						if (this.callEvent("onDynXLS",this._current_load))
							this.load(this.xmlFileUrl+dhtmlx.url(this.xmlFileUrl)+"posStart="+this._current_load[0]+"&count="+this._current_load[1], this._data_type);
					}
					return;
				} else {
	               	if (this._tgle){
	               		this._updateLine(this._h2.get[this.rowsBuffer[j].idd],this.rowsBuffer[j]);
	               		this._updateParentLine(this._h2.get[this.rowsBuffer[j].idd],this.rowsBuffer[j]);
	           		}
					if (j && j==(this._realfake?this._fake:this)["_r_select"]){
						this.selectCell(j, this.cell?this.cell._cellIndex:0, true);
					}
				}
		}
	};
	if (this._fake && !this._realfake && this.multiLine)
		this._fake.objBox.scrollTop = this.objBox.scrollTop

	// deleteステータスをcssに反映
	for (var i=0;i<this.getRowsNum();i++){
		// render前(未表示)の行はスキップ
		if (this.rowsBuffer[i]._parser) continue;
		var row = this.render_row(i);
		if( this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
			$(row).addClass(BlenderGrid.CSS_CLASS_ROW_DELETED);
		}else {
			$(row).removeClass(BlenderGrid.CSS_CLASS_ROW_DELETED);
		}
	}
};

BlenderGrid.prototype.cellsv = function(row_id, col){
	if (arguments.length == 0) {
		return this.cells4(this.cell);
	}

	var cell = null;

	var row_index = this.getRowIndex(row_id);

	do {

		var r = this.render_row(row_index);
		for( var i=0; i<r.childNodes.length; i++ ) {
			if( r.childNodes[i]._cellIndex==col ) {
				cell = r.childNodes[i];
				break;
			}
		}

		if( null==cell ) {
			row_index--;
		}

	} while( null==cell && row_index>=0 );

	return (null!=cell ? this.cells4(cell) : null);
}

/**
 * 精査処理(ロジックのマッピング情報)を初期化する。
 *
 * @method _init_validate
 */
BlenderGrid.prototype._init_validate = function(){
	// NOP
}

/**
 * 精査処理を実施し、エラーのあるセルはエラーマークを付与する。
 *
 * @method _validate
 * @param eXcell {eXcell} セルオブジェクト
 * @param rowId {string} 行Id
 * @param colIdx {number} 列インデックス
 * @param value {object} 値
 * @return {boolean} 精査エラーありの場合true、なしの場合false
 */
BlenderGrid.prototype._validate = function(eXcell,rowId,colIdx,value){
	var ret = this._validValue(rowId,colIdx,value);
	if( ret ) {
		this._setErrorMark(eXcell);
	}else {
		this._clearErrorMark(eXcell);
	}
	return ret;
}

/**
 * 精査判定を実施する。
 *
 * @method _validValue
 * @param rowId {string} 行Id
 * @param colIdx {number} 列インデックス
 * @param value {object} 値
 * @return {boolean} 精査エラーありの場合true、なしの場合false
 */
BlenderGrid.prototype._validValue = function(rowId,colIdx,value){
	return false;
}

/**
 * 精査再判定を実施する。
 *
 * @method revalidate
 * @param force {boolean} 非エラーセルに対してのみ実施する場合、false(デフォルト)。
 *                         全セルに対して実施する場合、true。
 */
BlenderGrid.prototype.revalidate = function(force){
	this._update_srnd_view_pos(0,this.rowsBuffer.length);

	for( var i=0; i<this.getRowsNum(); i++ ) {
		var row = this.render_row(i);

		for( var j=0; j<this.getColumnsNum(); j++ ) {
			var c = this.cells3(row, j);
			var value = c.getValue();

			if( force || !this._hasErrorMark(c) ) {
				if( this._validate(c,row.idd,j,value) ) {
					c.cell.wasChanged=true;
				}
			}
		}
	}
}

/**
 * コンテキストメニューの構成情報を初期化する。
 *
 * @method _init_context_menu
 */
BlenderGrid.prototype._init_context_menu = function() {
	// NOP
}

/**
 * 編集済みマークを付与する。
 *
 * @method _setDirtyMark
 * @param eXcell セルオブジェクト(eXcell)
 */
BlenderGrid.prototype._setDirtyMark = function(eXcell){
//	eXcell.setTextColor(this.dirtyColor);
	eXcell.addClass(BlenderGrid.CSS_CLASS_DIRTY_CELL);
	eXcell.cell.wasChanged = true;
}

/**
 * 編集済みマークをクリアする。
 * @method _clearDirtyMark
 * @param eXcell セルオブジェクト(eXcell)
 */
BlenderGrid.prototype._clearDirtyMark = function(eXcell){
//	eXcell.setTextColor(this.standardColor);
	eXcell.removeClass(BlenderGrid.CSS_CLASS_DIRTY_CELL);
	eXcell.cell.removeAttribute("wasChanged");
}

/**
 * エラーマークを付与する。
 * @method _setErrorMark
 * @param eXcell セルオブジェクト(eXcell)
 */
BlenderGrid.prototype._setErrorMark = function(eXcell){
	eXcell.addClass(BlenderGrid.CSS_CLASS_ERROR_CELL);
}

/**
 * エラーマークを有無を確認する。
 * @method _hasErrorMark
 * @param eXcell セルオブジェクト(eXcell)
 */
BlenderGrid.prototype._hasErrorMark = function(eXcell){
	return eXcell.hasClass(BlenderGrid.CSS_CLASS_ERROR_CELL);
}

/**
 * エラーマークをクリアする。
 * @method _clearErrorMark
 * @param eXcell セルオブジェクト(eXcell)
 */
BlenderGrid.prototype._clearErrorMark = function(eXcell){
	eXcell.removeClass(BlenderGrid.CSS_CLASS_ERROR_CELL);
}

/**
 * 属性情報を設定する。
 * @method putAttribute
 * @param name 属性名
 * @param val 属性値
 */
BlenderGrid.prototype.putAttribute = function(name, val){
	if( !this._userAttr ) {
		this._userAttr = {};
	}
	this._userAttr[name] = val;
}

/**
 * 属性情報を取得する。
 * @method getAttribute
 * @param name 属性名
 * @return 属性値
 */
BlenderGrid.prototype.getAttribute = function(name){
	if( !this._userAttr ) {
		this._userAttr = {};
	}
	return this._userAttr[name];
}

/**
 * 属性情報を削除する。
 * @method removeAttribute
 * @param name 属性名
 */
BlenderGrid.prototype.removeAttribute = function(name){
	delete this._userAttr[name];
}

/**
 * 属性名のprefixを使い情報を削除する。
 * @method removeAttributesByPrefix
 * @param prefix 属性名Prefix
 */
BlenderGrid.prototype.removeAttributesByPrefix = function(prefix){
	var tmp = {};
	for( name in this._userAttr ) {
		if( !name.startsWith(prefix) ){
			tmp[name] = this._userAttr[name];
		}
	}
	this._userAttr = tmp;
}

/**
 * 属性情報をクリアする。
 * @method clearAttribute
 */
BlenderGrid.prototype.clearAttribute = function(){
	this._userAttr = {};
}

/**
 * 編集有無を確認する。
 * @method isDirty
 * @return 編集有りの場合true、無しの場合false
 */
BlenderGrid.prototype.isDirty = function(){
	return this.dirtyFlg;
}

/**
 * 編集有無を設定する。
 * @method setDirtyFlg
 * @param flg 編集有りの場合true、無しの場合false
 */
BlenderGrid.prototype.setDirtyFlg = function(flg){
	this.dirtyFlg = flg;
}

/**
 * エラー有無を確認する。
 * 削除行以外の行に、精査エラーセルがあればエラー有と判定する。
 * @method hasError
 * @return エラー有りの場合true、無しの場合false
 */
BlenderGrid.prototype.hasError = function(){
	var ret = false;

	this._update_srnd_view_pos(0,this.rowsBuffer.length);

	for( var i=0; i<this.getRowsNum(); i++ ) {
		var row = this.render_row(i);
		if( this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
			continue;
		}

		for( var j=0; j<this.getColumnsNum(); j++ ) {
			var cell = (row._childIndexes ?
				row.childNodes[row._childIndexes[j]] : row.childNodes[j]);
			var c = this.cells4(cell);

			var isValidTarget = (c.isValidationTarget ? c.isValidationTarget() : (!c.isDisabled() && c.wasChanged()) );
			if( isValidTarget ) {
				if( this._hasErrorMark(c) ) {
					ret = true;
					break;
				}
			}
		}
		if( ret ) break;
	}
	return ret;
}

/**
 * 行に指定したステータスが付与されているか確認する。
 * @method hasRowStatus
 * @param row 行オブジェクト
 * @param status ステータス文字列
 */
BlenderGrid.prototype.hasRowStatus=function(row,status){
	if( !row.status ) {
		row.status = "";
	}
	return row && jQuery.inArray( status, row.status.split(/\s+/) ) > -1;
};

/**
 * 行に指定したステータスを付与する。
 *
 * @method addRowStatus
 * @param row 行オブジェクト
 * @param statuses ステータス文字列(複数の場合はスペースで区切る)
 */
BlenderGrid.prototype.addRowStatus=function(row,statuses){
	var self = this;
	jQuery.each((statuses || "").split(/\s+/), function(i, status){
		if( !self.hasRowStatus(row,status) ) {
			row.status += (row.status ? " " : "") + status;
		}
	});
};

/**
 * 行から指定したステータスを削除する。
 *
 * @method removeRowStatus
 * @param row 行オブジェクト
 * @param statuses ステータス文字列(複数の場合はスペースで区切る)
 */
BlenderGrid.prototype.removeRowStatus=function(row,statuses){
	statuses = (statuses || "").split(/\s+/);

	var self = this;
	row.status = (statuses !== undefined ?
		jQuery.grep(row.status.split(/\s+/), function(status){
			var ret = true;
			for( var i=0; i<statuses.length; i++ ) {
				if( statuses[i] == status ) {
					ret = false;
				}
			}
			return ret;
		}).join(" ") : "");
};

/**
 * 絶対座標を取得する。
 * @method offset
 * @return {top:Y値, left:X値}
 */
BlenderGrid.prototype.offset = function(){
	return this.targetObj.offset();
}

/**
 * 親要素からの相対座標を取得する。
 * @method position
 * @return {top:Y値, left:X値}
 */
BlenderGrid.prototype.position = function(){
	return this.targetObj.position();
}

/**
 * リロケーションする。
 * (現在split有効の場合は実施不可能！)
 * @method relocation
 * @param top Y値
 * @param left X値
 */
BlenderGrid.prototype.relocation = function(top, left){
	if( top !== null ) {
		this.targetObj.css("top",top+"px");
	}
	if( left !== null ) {
		this.targetObj.css("left",left+"px");
	}
}

/**
 * グリッドの幅を取得する。
 *
 * @property with
 * @readonly
 * @return {number} グリッドの幅
 */
BlenderGrid.prototype.width = function(){
	return this.targetObj.width();
}

/**
 * グリッドの高さを取得する。
 *
 * @property height
 * @readonly
 * @return {number} グリッドの高さ
 */
BlenderGrid.prototype.height = function(){
	return this.targetObj.height();
}

/**
 * カスタムスクロールバーを有効にする。
 * codebase/customscroll.css
 * codebase/customscroll.js
 * をインクルードする必要がある。
 *
 * @method enableCustomScroll
 */
BlenderGrid.prototype.enableCustomScroll = function(){
	if (dhtmlx.CustomScroll)
		dhtmlx.CustomScroll.enable(this);
	this._isCustomScroll = true;
}

/**
 * 水平スクロールバーを無効化する。
 * ※Grid幅に合うように列幅を調整したが、水平スクロールバーが
 * 表示されてしまうような場合に呼び出すと改善されます。
 *
 * @method disableHorizontalScroll
 */
BlenderGrid.prototype.disableHorizontalScroll = function(){
	this.objBox.style.overflow="visible";
	this.objBox.style.overflowX="hidden";
	this.objBox.style.overflowY="auto";
}

/**
 * グリッドを指定の幅・高さでリサイズする。
 * (現在split有効の場合は実施不可能！)
 *
 * @method resize
 * @param width {number} 幅
 * @param height {number} 高さ
 */
BlenderGrid.prototype.resize = function(width, height){
	this.targetObj.width(width);
	this.targetObj.height(height);
	this.setSizes();
}

/**
 * グリッドのヘッダの高さを指定する。
 * grid.setHeaderHeight(50);
 * grid.setHeaderHeight("50px");
 *
 * @method setHeaderHeight
 * @param height {number} 高さ
 */
BlenderGrid.prototype.setHeaderHeight = function(height){
	if( isNumber(height) ) {
		height = height + "px";
	}else {
		// それ以外の場合はそのまま利用
	}

	$("#"+this.tagId+" > .xhdr > .hdr > tbody > tr:eq(1)").css("height", height);
}

/**
 * 区切り文字で列挙したカラム名の文字列を設定する。
 * 区切り文字はデフォルトは、カンマ。(setDelimiterメソッドで任意に変更できる。)
 *
 * @method setColNames
 * @param nameStr {string} 区切り文字で列挙したカラム名の文字列 "カラム名1,カラム名2,カラム名3,..."
 */
BlenderGrid.prototype.setColNames = function(nameStr){
	this.colNames=nameStr.split(this.delim);
}

/**
 * リクエストデータ(json形式)を取得する。
 * 本メソッドを実施するには、setColNamesによるカラム名設定が必要。
 *
 * @method getRequestValue
 * @param modifyDataOnly {boolean} true:変更行データのみ, false:全行データ(省略時)
 * @param includeDelete {boolean} true:削除行を含む, false:削除行を含まない(省略時)
 * @return {object} jsonデータ{"#rowId":["値1","値2","値3",...], "キー":["値1","値2","値3",...], ...}
 */
BlenderGrid.prototype.getRequestValue = function(modifyDataOnly,includeDelete){
	var ret = {};

	ret["#rowId"] = [];
	for( var i=0; i<this.colNames.length; i++ ) {
		//alert(this.colNames[i]);
		ret[this.colNames[i]] = [];
	}

	this._update_srnd_view_pos(0,this.rowsBuffer.length);

	var dataIndex = 0;

	for( var i=0; i<this.getRowsNum(); i++ ) {
		var row = this.render_row(i);
		if( !includeDelete && this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
			continue;
		}

		var changeFlg = false;
		for( var j=0; j<this.getColumnsNum(); j++ ) {
			var c = this.cells3(row, j);
			if( c.wasChanged() ) {
				changeFlg = true;
				break;

			}
		}
		if( !modifyDataOnly || changeFlg ) {
			//alert("変更あり! rowId: "+row.idd);
			ret["#rowId"][dataIndex] = row.idd;
			for( var j=0; j<this.colNames.length; j++ ) {
				var c = this.cells3(row, j);
				//ret[this.colNames[j]][dataIndex] = (c.getValue()!=null ? c.getValue() : "");
				//ret[this.colNames[c.cell._cellIndex]][dataIndex] = (c.getValue()!=null ? c.getValue() : "");
				for( var rs=0; rs<c.cell.rowSpan; rs++ ) {
					ret[this.colNames[c.cell._cellIndex]][dataIndex+rs] = (c.getValue()!=null ? c.getValue() : "");
				}
				//alert("rowId: "+rowId+", idx: "+j+" => "+c.getValue());
			}
			dataIndex++;
		}
	}
	return ret;
}

/**
 * 指定したカラム名に対応したカラムの参照情報(列インデックス)
 * を取得する。
 * @method getColRef
 * @param colName カラム名
 * @return 列インデックス(対応するカラムが存在しない場合-1)
 */
BlenderGrid.prototype.getColRef = function(colName){
	var ret = -1;
	for( var i=0; i<this.colNames.length; i++ ) {
		if( this.colNames[i]==colName ) {
			ret = i;
			break;
		}
	}
	return ret;
}

/**
 * 新規の空行を追加する。
 * この際、新規行の行IDは "newRow_"+(現在の行数+1) となる。
 * 本ルール以外で行を作成したい場合は、標準の addRow 関数を利用のこと。
 *
 * @method addNewEmptyRow
 * @param index 挿入箇所index。省略時は行末に追加。
 */
BlenderGrid.prototype.addNewEmptyRow = function(index){

	var newId = "newRow_" + (this.getRowsNum()+1);

	var tmp = [];
	for( var i=0; i<this.getColumnsNum(); i++ ) {
		tmp[tmp.length] = "";
	}
	var newVal = tmp.join(",");

	this.addRow(newId, newVal, index);
}

/**
 * 削除行IDリストを取得する。新規追加行を削除した場合は本応答には含まない。
 * @method getDeleteRowIds
 * @return ["#rowId1","#rowId2","#rowId3", ...}
 */
BlenderGrid.prototype.getDeleteRowIds = function(){
	var ret = [];

	this._update_srnd_view_pos(0,this.rowsBuffer.length);

	for( var i=0; i<this.getRowsNum(); i++ ) {
		var row = this.render_row(i);
		if( this.hasRowStatus(row,BlenderGrid.ROW_STATUS_DELETE) ) {
			if( !this.hasRowStatus(row,BlenderGrid.ROW_STATUS_NEW) ) {
				ret[ret.length] = row.idd;
			}
		}
	}
	return ret;
}

/**
 * セル種別の参照モード用マッピング情報を初期化する。
 * @method _init_readOnlyEXcellMap
 */
BlenderGrid.prototype._init_readOnlyEXcellMap = function(){
	this._readOnlyEXcellMap = {
		"bl_ro":      "bl_ro",
		"bl_ron":     "bl_ron",
		"bl_rosp":    "bl_rosp",
		"bl_ed":      "bl_ed_ne",
		"bl_edn":     "bl_edn_ne",
		"bl_edsp":    "bl_rosp",
		"bl_co":      "bl_co_ne",
		"bl_cotxt":   "bl_cotxt_ne",
		"bl_rotext":  "bl_rotext",
		"bl_coro":    "bl_coro",
		"bl_ch":      "bl_ch_ne",
		"bl_ch2":     "bl_ch2",
		"bl_ch_ne":   "bl_ch_ne",
		"bl_html":    "bl_html",
		"bl_link":    "bl_link",
		"bl_linkn":   "bl_linkn"
	};
}

/**
 * セル種別の削除行用マッピング情報を初期化する。
 * 本マッピング情報にない場合は、参照モード用マッピング情報が適用される。
 * @method _init_deleteEXcellMap
 */
BlenderGrid.prototype._init_deleteEXcellMap = function(){
	this._deleteEXcellMap = {
		"bl_link":    "bl_link_ne",
		"bl_linkn":   "bl_linkn_ne"
	};
}

/**
 * セル種別の参照モード用セル種別を取得する。
 * @method _getReadOnlyCellType
 * @param cellType セル種別
 * @return 参照モード用セル種別
 */
BlenderGrid.prototype._getReadOnlyCellType = function(cellType){
	//var orgCellType = cellType;
	cellType = (cellType!=null ? cellType : "");

	if( this._readOnlyEXcellMap[cellType] ) {
		cellType = this._readOnlyEXcellMap[cellType];
	}else {
		cellType = (cellType.endsWith("_ne") ? cellType : cellType+"_ne");
		var tmpCellType = window["eXcell_"+cellType];
		if( tmpCellType ) {
			// ok NOP
		}else {
			cellType = "bl_ro";
		}
	}
	//alert(orgCellType + " ->> " + cellType);
	return cellType;
}

/**
 * セル種別の削除行用セル種別を取得する。
 * @method _getDeleteCellType
 * @param cellType セル種別
 * @return 削除行用セル種別
 */
BlenderGrid.prototype._getDeleteCellType = function(cellType){
	cellType = (cellType!=null ? cellType : "");

	if( this._deleteEXcellMap[cellType] ) {
		cellType = this._deleteEXcellMap[cellType];
	}else {
		cellType = this._getReadOnlyCellType(cellType);
	}

	return cellType;
}

/**
 * セル種別の編集モード用セル種別を取得する。
 * @method _getEditableCellType
 * @param cellType セル種別
 * @return 編集モード用セル種別
 */
BlenderGrid.prototype._getEditableCellType = function(cellType){
	var ret = null;
	if( this.readonlyMode==0 ) {
		for (editableCellType in this._readOnlyEXcellMap) {
			var readOnlyCellType = this._readOnlyEXcellMap[editableCellType];
			if( readOnlyCellType == cellType ) {
				ret = editableCellType;
				break;
			}
		}
		if( !ret ) {
			cellType = (cellType.endsWith("_ne") ? cellType.substring(0,cellType.length-3) : cellType);
			//alert("cellType: "+cellType);
	 		var tmpCellType = window["eXcell_"+cellType];
			if( tmpCellType ) {
				ret = cellType;
			}else {
				ret = "bl_ed";
			}
		}
	}else {
		ret = cellType;
	}
	return ret;
}

/**
 * セルの状態を変更し、参照モードに設定する。
 * ※注意
 * 本処理はデータ読込前に実施する場合と、データ読込後に実施する場合で
 * 性能に差が発生する。これはデータ読込前に実施した場合、ExcellTypeの
 * 設定に列属性(ColumnExcellType)を使用するが、データ読込後に実施した場合は
 * セル属性(CellExcellType)を使用するためである。
 * 同一列内に異なるセル種別が存在しない場合(主に一覧表示系の処理)は、
 * データ読み込み前に本処理を呼び出し、同一列内に異なるセル種別が存在する
 * 場合(主に明細編集系の処理)は、データ読込後に本処理を呼び出すこと。
 *
 * @method readonly
 * @param type "column": 列タイプ、"cell": セルタイプ
 */
BlenderGrid.prototype.readonly = function(type){
	type = type || this.defaultReadonlyType;

	if( type === BlenderGrid.READONLY_TYPE_COLUMN ) {
		if( this.readonlyMode==0 ) {
			for (var j=0;j<this.getColumnsNum();j++){
				var cellType = this.cellType[j];
				cellType = this._getReadOnlyCellType(cellType);
				this.setColumnExcellType(j,cellType);
			}
		}
		this.readonlyMode = 1;
	}else if( type == BlenderGrid.READONLY_TYPE_CELL ) {
		if( this.getRowsNum() > 0 ) {
			for( var i=0; i<this.getRowsNum(); i++ ) {
				var row = this.render_row(i);
				for (var j=0;j<this.getColumnsNum();j++){
					var c = this.cells3(row, j);
					if( c.hasClass("cateHdr") || c.hasClass("hdr") ) continue;

					var cell = c.cell;
					var cellType = cell._cellType;
					if( cellType ) {
						cellType = this._getReadOnlyCellType(cellType);
						this.changeCellType(row, j, cellType);
					}
				}
			}
		}
		this.readonlyMode = 2;
	}
}

/**
 * 行削除時セル種別変更フラグを設定する。
 *
 * @method setDelRowCellTypeChange
 * @param delRowCellTypeChange 行削除時セル種別変更フラグ
 *        "false,true,..." あるいは [false,true,...] (どちらもtrueの場合セル種別変更あり)
 */
BlenderGrid.prototype.setDelRowCellTypeChange = function(delRowCellTypeChange){
	if( isString(delRowCellTypeChange) ) {
		delRowCellTypeChange = delRowCellTypeChange.split(this.delim);
		for( var i=0; i<delRowCellTypeChange.length; i++ ) {
			delRowCellTypeChange[i] = ("true"==delRowCellTypeChange[i].toLowerCase() ? true : false);
		}
	}
	this.delRowCellTypeChange = delRowCellTypeChange;
}

/**
 * 行削除時セル種別変更フラグを取得する。
 *
 * @method isDelRowCellTypeChange
 * @param colIdx 列インデックス
 * @return 行削除時セル種別変更フラグ(trueの場合変更あり)
 */
BlenderGrid.prototype.isDelRowCellTypeChange = function(colIdx){
	var idx = (colIdx<this.delRowCellTypeChange.length ? colIdx : this.delRowCellTypeChange.length-1);
	return this.delRowCellTypeChange[idx];
}

/**
 * イベント割り当てをカスタマイズする。
 *
 * @method _custom_attachEvent
 */
BlenderGrid.prototype._custom_attachEvent = function(){
	// NOP
}

/**
 * 列毎の数字フォーマットを設定する。
 * マスクのサンプルは以下の通り。
 * ex.
 *  "0,000.000" 小数点第3桁まで表示
 *  "0,000.0##" 小数点第1桁まで表示。第2-3桁は0以外の場合表示。
 *  "0,000.###" 小数点第1-3桁は0以外の場合表示。
 *  "0,000.00_" 小数点第2桁まで表示。第3桁は0以外の場合表示(0の場合は空白)
 *  "0,000.___" 小数点第1-3桁は0以外の場合表示(0の場合は空白)
 *
 * @method setNumberFormat
 * @param mask マスク
 * @param colIdx 列インデックス
 * @param p_sep 数値セパレータ(省略可)
 * @param d_sep グループセパレータ(省略可)
 */
BlenderGrid.prototype.setNumberFormat = function(mask, cInd, p_sep, d_sep){
	this._maskArr[cInd] = this._parseNumberMask(mask, p_sep, d_sep);
}

/**
 * セル毎の数字フォーマットを設定する。
 * マスクのサンプルは以下の通り。
 * ex.
 *  "0,000.000" 小数点第3桁まで表示
 *  "0,000.0##" 小数点第1桁まで表示。第2-3桁は0以外の場合表示。
 *  "0,000.###" 小数点第1-3桁は0以外の場合表示。
 *  "0,000.00_" 小数点第2桁まで表示。第3桁は0以外の場合表示(0の場合は空白)
 *  "0,000.___" 小数点第1-3桁は0以外の場合表示(0の場合は空白)
 *
 * @method setCellNumberFormat
 * @param rowId 行Id
 * @param colIdx 列インデックス
 * @param mask マスク
 * @param p_sep 数値セパレータ(省略可)
 * @param d_sep グループセパレータ(省略可)
 */
BlenderGrid.prototype.setCellNumberFormat = function(rowId, colIdx, mask, p_sep, d_sep){
	this.putAttribute("cell-number-format["+rowId+"-"+colIdx+"]",
		this._parseNumberMask(mask, p_sep, d_sep));
}

/**
 * 数字フォーマットを解析する。
 * マスクのサンプルは以下の通り。
 * ex.
 *  "0,000.000" 小数点第3桁まで表示
 *  "0,000.0##" 小数点第1桁まで表示。第2-3桁は0以外の場合表示。
 *  "0,000.###" 小数点第1-3桁は0以外の場合表示。
 *  "0,000.00_" 小数点第2桁まで表示。第3桁は0以外の場合表示(0の場合は空白)
 *  "0,000.___" 小数点第1-3桁は0以外の場合表示(0の場合は空白)
 *
 * @method _parseNumberMask
 * @param mask マスク(ex. "0,000.00" "0,000.##" "0,000.0_" 等)
 * @param p_sep 数値セパレータ(省略可)
 * @param d_sep グループセパレータ(省略可)
 * @return 数字フォーマットデータ
 */
BlenderGrid.prototype._parseNumberMask = function(mask, p_sep, d_sep){
	var nmask = mask.replace(/[^0\,\.#_]*/g, "");
	var pfix = nmask.indexOf(".");
	if (pfix > -1)
		pfix=nmask.length-pfix-1;
	var dfix = nmask.indexOf(",");
	if (dfix > -1)
		dfix=nmask.length-pfix-2-dfix;

	var pfix_always = 0; // 表示有効桁数
	var pfix_fill_space = false; // true: 有効桁数分空白穴埋め
	if (pfix > -1){
		for( var i=nmask.length-pfix; i<nmask.length; i++ ) {
			var c = nmask.charAt(i);
			if( "#"==c ) {
				break;
			}else if( "_"==c ) {
				pfix_fill_space = true;
				break;
			}else {
				// 0の場合はそのまま繰り返す。
				pfix_always++;
			}
		}
	}

	if (typeof p_sep != "string")
		p_sep=this.i18n.decimal_separator;
	if (typeof d_sep != "string")
		d_sep=this.i18n.group_separator;

	var pref = mask.split(nmask)[0];
	var postf = mask.split(nmask)[1];

	return [
		pfix,
		dfix,
		pref,
		postf,
		p_sep,
		d_sep,
		pfix_always,
		pfix_fill_space
	];
}

/**
 * カラムの最小幅を設定する。
 *
 * @method setMinWidths
 */
BlenderGrid.prototype.setMinWidths=function(wp){
	this.minCellWidth=wp.split(this.delim);
};

/**
 * グリッド間をカーソルキーで移動できるように、リンク設定する。
 *
 * @method setupLink
 * @param top 上グリッド
 * @param bottom 下グリッド
 * @param left 左グリッド
 * @param right 右グリッド
 */
BlenderGrid.prototype.setupLink=function(top,bottom,left,right){
	this.topLinkGrid = top;
	this.bottomLinkGrid = bottom;
	this.leftLinkGrid = left;
	this.rightLinkGrid = right;

	top._UndoRedoBuffer = this._UndoRedoBuffer;
	bottom._UndoRedoBuffer = this._UndoRedoBuffer;
	left._UndoRedoBuffer = this._UndoRedoBuffer;
	right._UndoRedoBuffer = this._UndoRedoBuffer;

};

/**
 * カテゴリヘッダを設定する。
 *
 * @method setupCategoryHeader
 * @param rowIdx 行インデックス
 * @param title タイトル
 * @param img イメージ
 */
BlenderGrid.prototype.setupCategoryHeader = function(rowIdx,title,img){
	if( this.hdr ) {
		var tr = this.hdr.rows[1+rowIdx].childNodes[0];
		tr.firstChild.innerHTML = "<img src='"+img+"'> "+title;
		tr.className = "cateHdr";
	}
}

/**
 * ヘッダの色を設定する。
 *
 * @method setupHeaderColor
 * @param colIdx 列インデックス
 * @param backColor 背景色
 * @param txtColor 文字色
 * @param rowIdx 行インデックス(通常は省略。省略時は1。)
 */
BlenderGrid.prototype.setupHeaderColor = function(colIdx,backColor,txtColor,rowIdx){
	if( !rowIdx ) {
		rowIdx = 1;
	}
	for( var i=1; i<this.hdr.rows.length; i++ ) {
		if( backColor ) {
			this.hdr.rows[rowIdx].cells[colIdx].style.backgroundColor = backColor;
		}
		if( txtColor ) {
			this.hdr.rows[rowIdx].cells[colIdx].style.color = txtColor;
		}
	}
}

/**
 * セルのデフォルト値を設定する。
 * 本APIを呼び出すと既に設定ざれているデフォルト値情報は全て削除される。
 * 削除せずに残したい場合は keepSetting に true を設定すること。
 * (但しその分メモリが食われていくため、全く削除しないのは非推奨。
 * removeAttributesByPrefixを使い独自のタイミングで削除したい場合に限る。)
 *
 * @param data デフォルト値を示す JSON データ。(parseメソッドで設定するものと同じ構造)
 * @param keepSetting 既に設定されているデフォルト値情報を維持するか否か。trueが指定された場合は維持する。
 */
BlenderGrid.prototype.setupDefaultValue = function(data, keepSetting){

	this.defaultValueSupport = true; // デフォルト値処理を有効化

	if( !keepSetting ) {
		this.removeAttributesByPrefix("default-cell-data");
	}

	for( var r=0; r<data.rows.length; r++ ) {
		var rowId = data.rows[r].id;
		var rowData = data.rows[r].data;

		for( var c=0; c<rowData.length; c++ ) {
			if( null==rowData[c] ) continue;

			this.putAttribute("default-cell-data["+rowId+"-"+c+"]", rowData[c]);
		}
	}
}

/**
 * Gridコンポーネント(セルベース)
 *
 * @module BlenderGrid
 * @class BlenderCellBaseGrid
 * @constractor
 * @param id {string} div要素のid
 */
function BlenderCellBaseGrid(id){
	this.entryData = [];
	this.maxRowIdx = -1;
	this.maxColIdx = -1;
	this.jsonBaseName = null;
	this.remarksColumnEnable = false; // 備考欄有効
	this.validRuleRemarksEnable = false; // 備考欄精査条件設定有効
	this.remarksMargeEnable = false; // 備考欄マージ有効
	this.skin = "blender_cb";

	BlenderGrid.call(this, id);

	this.defaultReadonlyType = BlenderGrid.READONLY_TYPE_CELL; // デフォルトのReadOnly種別

	var self = this;

	this.enableColSpan(true);

	this._blenderGridInit = this.init;
	this.init = function() {
		this.i18n = BlenderDhtmlxCustomSettings.gridLangData;
		if (this.lang == null) {
			for(var key in this.i18n) {
				if (this.i18n[key] && this.i18n[key]["selectBtnLabel"]) {
					this.lang = key;
					break;
				}
			}
		}
		this.setSkin(this.skin);
		this._blenderGridInit();
		this.detachHeader(0);
	}

	this.parse = function(data, call, type){
		var inData = data;
		data = this.createBaseData();

		// baseデータ作成
		if (arguments.length == 2 && typeof call != "function"){
			type=call;
			call=null
		};
		type=type||"xml";
		this._data_type=type;
		data=this["_process_"+type](data);

		if (!this._contextCallTimer)
			this.callEvent("onXLE", [this,0,0,data]);
		if (call)call()

		var numOfColumnsPerSet = (this.remarksColumnEnable ? 3 : 2);

		// ヘッダスタイル適用
		for( var i=0; i<this.getRowsNum(); i++ ) {
			var row = this.render_row(i);

			for( var j=0; j<this.getColumnsNum(); j++ ) {
				switch( j%numOfColumnsPerSet ) {
					case 0: // ヘッダスタイル
						this.changeCellType(row,j,"bl_html");
						var c = this.cells3(row,j);
						c.addClass("hdr");
						c.setHorAlign("center");
						break;
					case 1:
						break;
					case 2: // 備考スタイル
						this.changeCellType(row,j,"bl_ro");
						var c = this.cells3(row,j);
						c.setHorAlign("left");
						break;
				}
			}
		}

		// セル種別反映
		this.updateCellStyle();

		// 指定データ反映
		for( var i=0; i<this.getRowsNum(); i++ ) {
			var row = this.render_row(i);
			for( var j=0; j<this.getColumnsNum(); j++ ) {
				var propName = this.getAttribute("propName"+"["+row.idd+"-"+j+"]");
				if( propName ) {
					var val = BlenderUtil.getPropValue(inData, (this.jsonBaseName ? this.jsonBaseName+"." : "")+propName);
					if (val === void 0) {
						val = null;
					}

					var c = this.cells3(row, j);
					c.setValue(val);

					if( this.remarksColumnEnable ) {
						// 備考欄が有効なら
						if( this.validRuleRemarksEnable && this._validDescription ) {
							var remarks = this._validDescription(row.idd,j,c);
							var remarksCell = this.cells3(row, j+1);
							if( !remarksCell.getValue() ) {
								remarksCell.setValue(remarks);
							}else {
								if( this.remarksMargeEnable ) {
									remarksCell.setValue(remarks+remarksCell.getValue());
								}
							}
						}
					}

				}
			}
		}

		// カスタム変更処理を行う。
		this._effect_custom();

		// セル結合
		setupColSpan(this,0,this.getRowsNum()-1);

		// セルモードReadOnlyの場合編集不可に設定
		if( this.readonlyMode==2 ) {
			this.readonly();
		}
	}
};

// Extends
BlenderCellBaseGrid.inherit(BlenderGrid);

/**
 * 移動キーの制御
 *
 * @method processMoveKey
 * @param code キーコード
 */
BlenderCellBaseGrid.prototype.processMoveKey = function(code){
	var ret = true;

	var rowId = this.getSelectedRowId();
	if( !rowId ) return false;
	var rowIdx = this.getRowIndex(rowId);
	var colIdx = this.getSelectedCellIndex();

	if( !this.editor ) {
		var hctrl = 0;
		var vctrl = 0;

		switch( code ) {
			case 37: // left key
				hctrl = -1;
				break;
			case 39: // right key
				hctrl = 1;
				break;
			case 38: // up key
				vctrl = -1;
				break;
			case 40: // down key
				vctrl = 1;
				break;
		}

		if( hctrl!=0 ) {
				while( true ) {
					colIdx += hctrl;

					if( colIdx<0 || colIdx>=this.getColumnsNum() ) break;
					var c = this.cells2(rowIdx, colIdx);
					if( !(c.hasClass("hdr") || c.hasClass("cateHdr") || c.hasClass("empty")) ) {
						break;
					}
				}
		}

		if( vctrl!=0 ) {
				while( true ) {
					rowIdx += vctrl;

					if( rowIdx<0 || rowIdx>=this.getRowsNum() ) break;
					var c = this.cells2(rowIdx, colIdx);
					if( !(c.hasClass("hdr") || c.hasClass("cateHdr") || c.hasClass("empty")) ) {
						break;
					}
				}
		}

		if( rowIdx>=0 && rowIdx<this.getRowsNum()
		 && colIdx>=0 && colIdx<this.getColumnsNum() ) {
			this.selectCell(rowIdx, colIdx, true, true, false, true);
		}
		ret = false;
	}
	return ret;
}

/**
 * 備考欄を有効にする。
 *
 * @method enableRemarksColumn
 */
BlenderGrid.prototype.enableRemarksColumn = function(){
	this.remarksColumnEnable = true;
}

/**
 * 備考欄精査条件設定を有効にする。
 *
 * @method enableValidRuleRemarks
 */
BlenderGrid.prototype.enableValidRuleRemarks = function(){
	this.validRuleRemarksEnable = true;
}

/**
 * 備考欄マージを有効にする。
 *
 * @method enableRemarksMarge
 */
BlenderGrid.prototype.enableRemarksMarge = function(){
	this.remarksMargeEnable = true;
}

/**
 * Jsonデータベース名を設定する。
 *
 * @method setJsonBaseName
 * @param jsonBaseName Jsonデータベース名
 */
BlenderCellBaseGrid.prototype.setJsonBaseName = function(jsonBaseName){
	this.jsonBaseName = jsonBaseName;
}

/**
 * 編集データエントリー情報をクリアする。
 *
 * @method clearSetup
 */
BlenderCellBaseGrid.prototype.clearSetup = function(){
	for( var i=0; i<this.entryData.length; i++ ) {
		var rowId = this.entryData[i]["rowId"];
		var colIdx = this.entryData[i]["colIdx"];

		this.removeAttribute("propName["+rowId+"-"+colIdx+"]");
	}

	this.entryData.length = 0;
	this.maxRowIdx = -1;
	this.maxColIdx = -1;
}

/**
 * 編集データエントリー情報を設定する。
 *
 * @method setup
 * @param rowIdx 行インデックス
 * @param colIdx 列インデックス
 * @param title タイトル
 * @param propName プロパティ名
 * @param cellType セル種別
 * @param align 水平位置
 * @param remarks 備考
 */
BlenderCellBaseGrid.prototype.setup = function(rowIdx,colIdx,title,propName,cellType,align,remarks){
	var rowId = "row_"+rowIdx;

	this.entryData[this.entryData.length] = {
		rowIdx:   rowIdx,
		colIdx:   colIdx,
		rowId:    rowId,
		type:     "bizCell",
		title:    title,
		propName: propName,
		cellType: (cellType||"bl_ed"),
		align:    align,
		remarks:  remarks
	};
	this.maxRowIdx = (this.maxRowIdx>rowIdx ? this.maxRowIdx : rowIdx);
	this.maxColIdx = (this.maxColIdx>colIdx ? this.maxColIdx : colIdx);

	this.putAttribute("propName["+rowId+"-"+colIdx+"]",propName);
}

/**
 * カテゴリヘッダエントリー情報を設定する。
 *
 * @method setupCategoryHeader
 * @param rowIdx 行インデックス
 * @param colIdx 列インデックス
 * @param title タイトル
 * @param img カテゴリヘッダーの先頭に付与するイメージ
 */
BlenderCellBaseGrid.prototype.setupCategoryHeader = function(rowIdx,colIdx,title,img){
	var rowId = "row_"+rowIdx;

	this.entryData[this.entryData.length] = {
		rowIdx:   rowIdx,
		colIdx:   colIdx,
		rowId:    rowId,
		type:     "hdrCell",
		title:    (img ? "<img src='"+img+"'> "+title : title)
	};
	this.maxRowIdx = (this.maxRowIdx>rowIdx ? this.maxRowIdx : rowIdx);
	this.maxColIdx = (this.maxColIdx>colIdx ? this.maxColIdx : colIdx);
}

/**
 * 空エントリー情報を設定する。
 * @method setupEmpty
 * @param rowIdx 行インデックス
 * @param colIdx 列インデックス
 */
BlenderCellBaseGrid.prototype.setupEmpty = function(rowIdx,colIdx){
	var rowId = "row_"+rowIdx;

	this.entryData[this.entryData.length] = {
		rowIdx:   rowIdx,
		colIdx:   colIdx,
		rowId:    rowId,
		type:     "emptyCell"
	};
	this.maxRowIdx = (this.maxRowIdx>rowIdx ? this.maxRowIdx : rowIdx);
	this.maxColIdx = (this.maxColIdx>colIdx ? this.maxColIdx : colIdx);
}

/**
 * エントリー情報から空jsonデータを作成する。
 * @method createBaseData
 */
BlenderCellBaseGrid.prototype.createBaseData = function(){
	//alert("maxRowIdx: "+this.maxRowIdx+"\nmaxColIdx: "+this.maxColIdx);

	var maxColNum = (this.maxColIdx+1>this.getColumnsNum() ? this.maxColIdx+1 : this.getColumnsNum());

	var ret = {};
	var rows = [];
	for( var i=0; i<(this.maxRowIdx+1); i++ ) {
		var cellData = [];
		for( var j=0; j<maxColNum; j++ ) {
			cellData[cellData.length] = "#cspan";
		}

		rows[rows.length] = {
			id:   "row_"+i,
			data: cellData
		};
	}

	for( var i=0; i<this.entryData.length; i++ ) {
		var title = this.entryData[i]["title"];
		var remarks = this.entryData[i]["remarks"];

		if( this.getCellValidRule ) {
			var rowId = this.entryData[i]["rowId"];
			var colIdx = this.entryData[i]["colIdx"];

			var ruleData = this.getCellValidRule(rowId,colIdx);
			if( ruleData ) {
				var ruleNames = ruleData[0].split(":");
				for( var j=0; j<ruleNames.length; j++ ) {
					if( ruleNames[j] == "required" ) {
//						title += "&nbsp;<font color='white'>*</font>";
						title += "&nbsp;*";
						break;
					}
				}
			}
		}

		rows[this.entryData[i]["rowIdx"]]["data"][this.entryData[i]["colIdx"]-1] = title;
		if(this.remarksColumnEnable && this.entryData[i]["type"]=="bizCell") {
			rows[this.entryData[i]["rowIdx"]]["data"][this.entryData[i]["colIdx"]+1] = remarks;
		}
		//alert(rows[this.entryData[i]["rowIdx"]]["data"][this.entryData[i]["colIdx"]-1]);
	}
	ret["rows"] = rows;

	return ret;
}

/**
 * エントリーデータに基づきセルスタイルを更新する。
 *
 * @method updateCellStyle
 */
BlenderCellBaseGrid.prototype.updateCellStyle = function(){
	for( var i=0; i<this.entryData.length; i++ ) {
		var rowId = this.entryData[i]["rowId"];
		var colIdx = this.entryData[i]["colIdx"];
		var type = this.entryData[i]["type"];
		var cellType = this.entryData[i]["cellType"];
		var align = this.entryData[i]["align"];

		//alert("rowId: "+rowId+", colIdx: "+colIdx+", cellType: "+cellType+", align: "+align)

		if( type == "bizCell" ) {
			var c = this.cells(rowId,colIdx);

			if( cellType ) {
				this.setCellExcellType(rowId,colIdx,cellType);
			}
			if( align ) {
				c.setHorAlign(align);
			}
		}else if( type == "hdrCell" ) {
			var c = this.cells(rowId,colIdx-1);
			c.removeClass("hdr");
			c.addClass("cateHdr");
		}else if( type == "emptyCell" ) {
			var c = this.cells(rowId,colIdx-1);
			c.removeClass("hdr");
			c.addClass("empty");
		}
	}
}

/**
 * セルのデフォルト値を設定する。
 * 本APIを呼び出すと既に設定ざれているデフォルト値情報は全て削除される。
 * 削除せずに残したい場合は keepSetting に true を設定すること。
 * (但しその分メモリが食われていくため、全く削除しないのは非推奨。
 * removeAttributesByPrefixを使い独自のタイミングで削除したい場合に限る。)
 *
 * @param data デフォルト値を示す JSON データ。(parseメソッドで設定するものと同じ構造)
 * @param keepSetting 既に設定されているデフォルト値情報を維持するか否か。trueが指定された場合は維持する。
 */
BlenderCellBaseGrid.prototype.setupDefaultValue = function(data, keepSetting) {

	this.defaultValueSupport = true; // デフォルト値処理を有効化

	if (!keepSetting) {
		this.removeAttributesByPrefix("default-cell-data");
	}

	for (var i = this.entryData.length - 1; i >= 0; i--) {
		var e = this.entryData[i];
		var rowId = e["rowId"];
		var colIdx = e["colIdx"];

		var propName = this.getAttribute("propName[" + rowId + "-" + colIdx + "]");
		if (propName) {
			var value = data[propName];
			if (value != null) {
				this.putAttribute("default-cell-data[" + rowId + "-" + colIdx +"]", value);
			}
		}
	}
};

/**
 * リクエストデータを取得する。
 *
 * @method getRequestValue
 * @return {"setupメソッドのプロパティ名":値, ...}
 */
BlenderCellBaseGrid.prototype.getRequestValue = function(modifyDataOnly){
	var ret = {};

	for( var i=0; i<this.entryData.length; i++ ) {
		var rowId = this.entryData[i]["rowId"];
		var colIdx = this.entryData[i]["colIdx"];

		var propName = this.getAttribute("propName"+"["+rowId+"-"+colIdx+"]");
		if( !propName ) continue;

		var c = this.cells(rowId, colIdx);
		ret[propName] = c.getValue();
	}

	return ret;
}

/**
 * 指定したプロパティに対応したセルの参照情報(行ID,列インデックス)を取得する。
 *
 * @method getCellRef
 * @param propName プロパティ名
 * @return セルの参照情報が格納された配列([0]:行ID,[1]:列インデックス)
 */
BlenderCellBaseGrid.prototype.getCellRef = function(propName){
	var ret = null;
	for( var i=0; i<this.entryData.length; i++ ) {
		var rowId = this.entryData[i]["rowId"];
		var colIdx = this.entryData[i]["colIdx"];

		if( this.getAttribute("propName"+"["+rowId+"-"+colIdx+"]")==propName ) {
			ret = [rowId,colIdx];
			break;
		}
	}
	return ret;
}

/**
 * 指定したプロパティに対応したセルを取得する。
 *
 * @method getCellByPropName
 * @param propName {string} プロパティ名
 * @return セル(プロパティ名に該当するセルがなければnull)
 */
BlenderCellBaseGrid.prototype.getCellByPropName = function(propName){

	// セル参照情報取得
	var cellRef = this.getCellRef(propName);
	// セルを取得
	return cellRef && this.cells(cellRef[0], cellRef[1]);
}

/**
 * カスタム変更処理を行う。
 *
 * @method _effect_custom
 */
BlenderCellBaseGrid.prototype._effect_custom = function(){
	// NOP
}

/*
Copyright MITSUBISHI Elec.
*/
